// TODO: What is all the below? We shouldn't be disabling all these rules
/* eslint-disable no-underscore-dangle */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable eqeqeq */
import { Location, PlatformLocation } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppInsightsService, DictionaryService, genTinyGUID , SawDust } from '@cudirect/shared-ui-library';
import { LenderService } from '@shared/service/lender/lender.service';
import { UserService } from '@workflow/ecp-shared/service/user/user.service';
import { FocusHelperService } from '@workflow/ecp-shared/service/focus-helper/focus-helper.service';
import { AdminPortalFeaturesService } from '@workflow/ecp-shared/service/user/admin-portal-features.service';
import { Info } from '@workflow/ecp-shared/constant/information.const';
import { ADDITIONAL_BENEFICIAL_COUNT, RESPONSIBLE_PARTIES, RESPONSIBLE_PARTIES_ISPARTY } from '@workflow/ecp-shared/constant/constants';
import { coAppSwitch, getPageIterationId, processPath } from '../utilities.service';
import { VisibleFunctionsService } from './visible-functions.service';
import { BundleHelperService } from '@shared/service/bundle-helper.service';
import { ValueLabelItem } from '@workflow/class/enum-item.class';
import { StatefulValue, PATH_ITERATION_SYMBOL } from '@workflow/class/stateful-value.class';
import { LogicFnRef, PrimitiveType } from '@workflow/class/workflow.type';
import { LogicFnContext, LogicService } from '@workflow/service/logic/logic.service';
// eslint-disable-next-line max-len
import { WorkflowPageNavigationStateService } from '@workflow/service/workflow-page-navigation-state/workflow-page-navigation-state.service';
import { WorkflowService } from '@workflow/service/workflow/workflow.service';
import { UIFieldMapping } from '../../component/building-block/dynamic-personal-info/dynamic-personal-info.const';
import { SlideOutContent } from '../../component/custom-pages/slideout-page/slideout-page.component';
import { DisclosureCategory } from '../../constant/disclosure-category.const';
import { PROTOCOL_MORTGAGE } from '../../product-helper';
import { Disclosure, DisclosureApplicant } from '../../types/disclosure.type';
import { coBorrowersPath } from '../../types/joint-applicant/applicant-stateful.class';
import { JointCreditManager } from '../../types/joint-applicant/joint-credit-manager.class';
import { PersonalDynamic } from '../../types/personal-dynamic.type';
import { ApplicationApiService } from '../application-api/application-api.service';
import { Name } from '../instaTouch/insta-touch.types';
import { L360Service } from '../l360/l360.service';
import { StatefulService } from '@app/service/stateful.service';
import { FieldInstance, FieldService } from '@workflow/class/field.service';
import { CustomFunctionsService } from './custom-functions.service';
import { FlowService } from '@workflow/class/flow.service';
import { OaoPageHelper } from '../../../oao/helper/oao-page.helper';

const BUSINESS_RESPONSIBLE_ID = 'oao-business-responsible-parties-list';
const BUSINESS_ADDITIONAL_ID = 'oao-business-additional-beneficial-list';
const FIRSTNAME = 'firstName';
const LASTNAME = 'lastName';
const ISRESPONSIBLITY = 'isResponsibleParty';
const PERCENTAGE = 'percentage';
const REMOVE_MULTIPLE_COMMAS_RX = /^[, ]+|[, ]+$|[, ]+/g;
const OAO_MEMBERSHIPID_STORAGE_ID = 'api:oaoMemberInformation/membership/membershipID';
const OAO_DROPDOWN_MEMBERSHIPID_STORAGE_ID = 'ss:oaoMemberInformation/membership/dropdownMembershipID';
const OAO_MEMBERSHIP_MIN_AGE_STORAGE_ID = 'api:oaoMemberInformation/membership/minAge';
const OAO_MEMBERSHIP_MAX_AGE_STORAGE_ID = 'api:oaoMemberInformation/membership/maxAge';
const OAO_MEMBERSHIP_IS_YOUTH_STORAGE_ID = 'api:oaoMemberInformation/membership/isYouth';
const AUTOFILLOPTION = 'autoFillOption';

const OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_EMAIL = 'api:oaoMemberInformation/businessInformation/responsibleParties/0/email';
const OAO_PRIMARY_APPLICANT_EMAIL = 'api:oaoMemberInformation/primaryApplicant/email';
const OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_MOBILENUMBER =
  'api:oaoMemberInformation/businessInformation/responsibleParties/0/mobileNumber';
const OAO_PRIMARY_APPLICANT_MOBILENUMBER = 'api:oaoMemberInformation/primaryApplicant/mobileNumber';
const OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_FIRSTNAME = 'api:oaoMemberInformation/businessInformation/responsibleParties/0/firstName';
const OAO_PRIMARY_APPLICANT_FIRSTNAME = 'api:oaoMemberInformation/primaryApplicant/firstName';
const OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_LASTNAME = 'api:oaoMemberInformation/businessInformation/responsibleParties/0/lastName';
const OAO_PRIMARY_APPLICANT_LASTNAME = 'api:oaoMemberInformation/primaryApplicant/lastName';

const buildEnumItem = (value, label?) => {
  return {
    label: label || value,
    value
  } as ValueLabelItem;
};

/**
 * Methods on this service get registered as "logic functions" on LogicService
 */
@Injectable({
  providedIn: 'root'
})
export class OnChangeFunctionsService {
  private logger = inject(SawDust).withContext({ component: 'OnChangeFunctionsService' });

  /**
   * Used to prevent double calls.
   */
  private readonly _flipCache: { [key: string]: boolean } = {};
  /** Branch User */
  private branchUserLoading = false;
  /** boolean to show membership change confirmation modal */
  public showMembershipChangeModal: boolean;
  /** set membership context on membership change */
  public oaoMembershipSelectionContext: LogicFnContext;
  private readonly statefulService = inject(StatefulService);
  private readonly fieldService = inject(FieldService);

  constructor(
    private readonly visibleFunctionsService: VisibleFunctionsService,
    private readonly location: Location,
    private readonly platformLocation: PlatformLocation,
    public readonly applicationApiService: ApplicationApiService,
    public readonly l360ApiService: L360Service,
    public readonly dictionaryService: DictionaryService,
    public readonly userService: UserService,
    private readonly lenderService: LenderService,
    public readonly router: Router,
    private readonly focusService: FocusHelperService,
    private readonly bundleHelperService: BundleHelperService,
    public readonly workflowService: WorkflowService,
    private readonly pageStateService: WorkflowPageNavigationStateService,
    private readonly appInsightsService: AppInsightsService,
    private readonly adminPortalFeaturesService: AdminPortalFeaturesService,
    protected readonly applicationInsightsService: AppInsightsService,
    private readonly customFunctionsService: CustomFunctionsService,
    private readonly flowService: FlowService,
    private readonly oaoPageHelper: OaoPageHelper,
    private readonly logicservice: LogicService
  ) {}

  /**
   * Adjust array based on total amount
   * @param context page and iteration info
   * @param value value for less than
   */
  public arrayAdjustOnMinimumAmount = (context: LogicFnContext, value: number): void => {
    const storageId = context.field.config.storageId;
    const arrayRoot = storageId.split('/$')[0].split('$')[0];

    if (this.statefulService.isArrayAdjusting(arrayRoot)) {
      return; // already adjusting
    }

    const currentSize = this.statefulService.arraySize(arrayRoot);
    let sum = 0;
    const num = 100;
    let remaining = value;
    let container: StatefulValue;
    for (let i = 0; i < currentSize; i++) {
      container = this.statefulService.wrap(storageId, i);
      remaining = Math.round(remaining * num) / num;
      if (remaining <= 0) {
        for (let j = currentSize - 1; i <= j; j--) {
          this.statefulService.arrayRemove(arrayRoot, j);
        }
        return;
      }

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      sum += container.valueNumberOnly;
      remaining -= container.valueNumberOnly;
    }

    if (remaining > 0 && (!container || container.valueNumber)) {
      this.statefulService.arrayAdd(arrayRoot);
    }
  };

  /**
   * OAO ONLY
   * validate and update array with given number of month
   * @param requiredMonth - minimum no of months
   * @param inputInYear - flag to decide input in month / year
   * @param relatedFieldId - any related that should be taken in to account
   * @param relativeInputInYear - flag to decide related input in month / year
   */
  public arrayAdjustOnMinimumMonth = (
    context: LogicFnContext,
    requiredMonth: number,
    inputInYear = false,
    relatedFieldId?: string,
    relativeInputInYear = false
  ): void => {
    const storageId = context.field.config.storageId;
    const relativeField = relatedFieldId
      ? this.fieldService.createField(relatedFieldId, context.field.flowId, context.field.iterationId, context.field.pageIterationId)
      : undefined;
    const isRelativefield = relativeField !== undefined;
    const arrayRoot = storageId.split('/$')[0].split('$')[0];
    const pageIterationId = getPageIterationId(context);
    const pageArrayRoot = processPath(arrayRoot, pageIterationId);
    const monthsPerYear = 12;
    const currentSize = this.statefulService.arraySize(arrayRoot, pageIterationId);
    const firstContainer = this.statefulService.wrap(storageId, 0, pageIterationId);
    const firstContainerSum = inputInYear ? firstContainer.valueNumberOnly * monthsPerYear : firstContainer.valueNumberOnly;
    let relativeFirstContainer;
    let relativeFirstContainerValue;

    if (this.statefulService.isArrayAdjusting(arrayRoot)) {
      return; // already adjusting
    }

    let sum = 0;
    sum = sum + firstContainerSum;
    if (isRelativefield) {
      relativeFirstContainer = this.statefulService.wrap(relativeField.config.storageId, 0, pageIterationId);
      relativeFirstContainerValue = relativeInputInYear
        ? relativeFirstContainer.valueNumberOnly * monthsPerYear
        : relativeFirstContainer.valueNumberOnly;
      sum += relativeFirstContainerValue;
    }

    this.setAdjustOnMinMonthValue({
      currentSize,
      storageId,
      pageIterationId,
      requiredMonth,
      sum,
      pageArrayRoot,
      inputInYear,
      relativeField,
      relativeInputInYear
    });
  };

  private setAdjustOnMinMonthValue(data: {
    currentSize: number;
    storageId: string;
    pageIterationId: number;
    requiredMonth;
    sum: number;
    pageArrayRoot: string;
    inputInYear;
    relativeField: FieldInstance;
    relativeInputInYear: boolean;
  }) {
    const { currentSize, storageId, pageIterationId, requiredMonth, pageArrayRoot, inputInYear, relativeField, relativeInputInYear } = data;
    let { sum } = data;
    const isRelativefield = relativeField !== undefined;
    const monthsPerYear = 12;
    let container: StatefulValue;
    let relativeContainer: StatefulValue;
    let removalIteration = currentSize - 1;
    for (let i = 0; i < currentSize; i++) {
      container = this.statefulService.wrap(storageId, i, pageIterationId);
      removalIteration = this.removeArrayRootIterationValue(currentSize, i, pageArrayRoot, requiredMonth, removalIteration, sum);
      if (i !== 0) {
        sum += inputInYear ? container.valueNumberOnly * monthsPerYear : container.valueNumberOnly;
      }

      if (isRelativefield && i !== 0) {
        relativeContainer = this.statefulService.wrap(relativeField.config.storageId, i, pageIterationId);
        sum += relativeInputInYear ? relativeContainer.valueNumberOnly * monthsPerYear : relativeContainer.valueNumberOnly;
      }
    }
    this.addArrayRootIterationValue(sum, requiredMonth, container, isRelativefield, relativeContainer, pageArrayRoot);
  }

  private removeArrayRootIterationValue(
    currentSize: number,
    index: number,
    pageArrayRoot: string,
    requiredMonth: number,
    removalIteration: number,
    sum: number
  ) {
    if (sum >= +requiredMonth && index <= currentSize - 1) {
      if (removalIteration !== 0) {
        this.statefulService.arrayRemove(pageArrayRoot, removalIteration);
      }
      removalIteration = removalIteration - 1;
    }
    return removalIteration;
  }

  private addArrayRootIterationValue(
    sum: number,
    requiredMonth: number,
    container: StatefulValue,
    isRelativefield: boolean,
    relativeContainer: StatefulValue,
    pageArrayRoot: string
  ) {
    if (
      sum < +requiredMonth &&
      (!container || container.valueNumber || (isRelativefield && !relativeContainer) || relativeContainer.valueNumber)
    ) {
      this.statefulService.arrayAdd(pageArrayRoot);
    }
  }

  // OAO ONLY
  public adjustOAOEmploymentOnMinimumMonths = (
    context: LogicFnContext,
    isYearField: boolean,
    minimumMonths: number,
    employmentStatus: string = null,
    relatedFieldId: string = null,
    isRelatedFieldAYear = false
  ): void => {
    const pageIterationId = getPageIterationId(context);
    const arrayStorageId = context.field.config.storageId.split('/$')[0].split('$')[0];
    const pageArrayRoot = processPath(arrayStorageId, pageIterationId);

    if (this.statefulService.isArrayAdjusting(arrayStorageId)) {
      return;
    }

    let totalMonthSum = 0;
    let shouldAddToArray = false;
    let cardsNeeded = 1;
    const currentArraySize = this.statefulService.arraySize(arrayStorageId, pageIterationId);
    const minimumGeneratedCards = employmentStatus === 'UnEmployed' || employmentStatus === 'Retired' ? 2 : 1;

    for (let i = 0; i < currentArraySize; i++) {
      const currentFieldValue = this.statefulService.wrap(context.field.config.storageId, i, pageIterationId).valueNumberOnly;
      let currentMonthSum = isYearField ? currentFieldValue * 12 : currentFieldValue;
      if (relatedFieldId != null) {
        const relatedFieldStorageId = this.fieldService.createField(relatedFieldId, context.field.flowId, i, pageIterationId).config
          .storageId;
        const relatedFieldValue = this.statefulService.wrap(relatedFieldStorageId, i, pageIterationId).valueNumberOnly;
        currentMonthSum += isRelatedFieldAYear ? relatedFieldValue * 12 : relatedFieldValue;
      }
      totalMonthSum += currentMonthSum;
      if (i === currentArraySize - 1) {
        shouldAddToArray = currentMonthSum !== 0;
      }
      if (totalMonthSum < minimumMonths) {
        cardsNeeded++;
      }
    }
    this.handleArrays(currentArraySize, minimumGeneratedCards, pageArrayRoot, shouldAddToArray, totalMonthSum, cardsNeeded, minimumMonths);
  };

  // eslint-disable-next-line max-len
  // Moved logic from above method for cognitive complexity.
  private handleArrays(
    currentArraySize,
    minimumGeneratedCards,
    pageArrayRoot,
    shouldAddToArray,
    totalMonthSum,
    cardsNeeded,
    minimumMonths
  ) {
    if (currentArraySize < minimumGeneratedCards) {
      this.addOrRemoveFromArray(minimumGeneratedCards - currentArraySize, pageArrayRoot, true);
    } else {
      if (shouldAddToArray && totalMonthSum < minimumMonths) {
        this.addOrRemoveFromArray(1, pageArrayRoot, true);
      }
      if (currentArraySize > cardsNeeded && totalMonthSum >= minimumMonths && currentArraySize > minimumGeneratedCards) {
        const cardsToRemove = currentArraySize - (cardsNeeded > minimumGeneratedCards ? cardsNeeded : minimumGeneratedCards);
        this.addOrRemoveFromArray(cardsToRemove, pageArrayRoot, false);
      }
    }
  }

  // TODO: confirm with Jesse if this fn is used anywhere??
  private readonly addOrRemoveFromArray = (numberToAddOrRemove: number, arrayStorageId: string, shouldAddToArray): void => {
    if (numberToAddOrRemove <= 0) {
      return;
    }
    if (numberToAddOrRemove === 1) {
      if (shouldAddToArray) {
        this.statefulService.arrayAdd(arrayStorageId);
      } else {
        this.statefulService.arrayRemove(arrayStorageId);
      }
      return;
    }
    if (shouldAddToArray) {
      this.statefulService.arrayAdd(arrayStorageId, () => {
        this.addOrRemoveFromArray(numberToAddOrRemove - 1, arrayStorageId, shouldAddToArray);
      });
    } else {
      this.statefulService.arrayRemove(arrayStorageId, null, () => {
        this.addOrRemoveFromArray(numberToAddOrRemove - 1, arrayStorageId, shouldAddToArray);
      });
    }
  };

  /**
   * OAO ONLY
   *
   * Updating array field value based on first array field value
   * @param context page and iteration info
   * @param fieldId array field path
   */
  public arrayFieldUpdateBasedOnfirstArrayField = (context: LogicFnContext, fieldId: string): void => {
    const storageId = fieldId;
    const arrayRoot = storageId.split('/$')[0].split('$')[0];
    const pageIterationId = context.field.pageIterationId;
    const currentSize = this.statefulService.arraySize(arrayRoot, pageIterationId);

    let prevContainer: StatefulValue;
    const currentContainervalue: PrimitiveType = this.statefulService.wrap(storageId, 0, pageIterationId).value;

    for (let i = 0; i < currentSize; i++) {
      prevContainer = this.statefulService.wrap(storageId, i, pageIterationId);
      if (prevContainer.value === undefined && (currentContainervalue === true || currentContainervalue === false)) {
        prevContainer.value = currentContainervalue;
      }
    }
  };

  /**
   * OAO ONLY
   * Updating field value based on first array field value
   * @param context page and iteration info
   * @param fieldId array field path
   * @param updatePath updating field path
   */
  public updatingFieldValueBasedonArrayField = (context: LogicFnContext, fieldId: string, updatePath: string): void => {
    const storageId = fieldId;
    const arrayZeroIndexValue = this.statefulService.wrap(storageId, 0, context.field.pageIterationId).value;
    this.statefulService.wrap(updatePath, undefined, context.field.pageIterationId).value = arrayZeroIndexValue;
  };

  /*
   * Updating firs array field based on field value
   * @param context page and iteration info
   * @param fieldId array field path
   * @param updatePath updating field path
   */
  public updatingFirstArrayFieldBasedonFieldValue = (context: LogicFnContext, fieldId: string, updatePath: string): void => {
    const storageId = fieldId;
    const storageValue = this.statefulService.wrap(storageId).value;
    this.statefulService.wrap(updatePath, 0).value = storageValue;
  };

  /**
   * Calls arrayAdjustOnMinimumYear after field has been patched.
   */
  public arrayAdjustOnMinimumYearCallBack = (context: LogicFnContext, requiredYears: number, fieldId?: string): void => {
    const field = fieldId
      ? this.fieldService.createField(fieldId, context.field.flowId, context.field.iterationId, context.field.pageIterationId)
      : context.field;
    this.statefulService.wrap(field.config.storageId, context.field.iterationId, context.field.pageIterationId).afterPatch(() => {
      this.arrayAdjustOnMinimumYear(context, requiredYears, fieldId);
    });
  };

  /**
   * Check whether more iterations should be added based on last cards' info
   * If there's no last card, we need at least one
   * @param context page and iteration info
   * @param requiredYears number of years required for adding new cards
   */
  public arrayAdjustOnMinimumYear = (context: LogicFnContext, requiredYears: number, fieldId?: string): void => {
    const field = fieldId
      ? this.fieldService.createField(fieldId, context.field.flowId, context.field.iterationId, context.field.pageIterationId)
      : context.field;
    const storageId = field.config.storageId;
    const arrayRoot = storageId.split('/$')[0].split('$')[0];
    const pageArrayRoot = processPath(arrayRoot, context.field.pageIterationId);
    const maxLength = 10;

    if (
      !fieldId &&
      (this.statefulService.isArrayAdjusting(arrayRoot) || (field.data.value && field.data.value.toString().length < maxLength))
    ) {
      return; // already adjusting
    }

    const currentSize = this.statefulService.arraySize(arrayRoot, context.field.pageIterationId);
    const iterationId = this.statefulService.arraySize(storageId, context.field.pageIterationId) - 1;

    if (currentSize > 0) {
      this.resetDateValues(currentSize, requiredYears, context.field.pageIterationId, context.field.config.storageId, pageArrayRoot);
      const isMissingTimeCoverage = this.visibleFunctionsService.missingTimeCoverage(context, storageId, +requiredYears);
      this.setDateValueOnMinimumYear(
        currentSize,
        requiredYears,
        context.field.pageIterationId,
        iterationId,
        context.field.config.storageId,
        pageArrayRoot,
        isMissingTimeCoverage
      );
    } else {
      this.statefulService.arrayAdd(pageArrayRoot);
    }
  };

  private setDateValueOnMinimumYear(
    currentSize: number,
    requiredYears,
    pageIterationId: number,
    iterationId: number,
    storageId: string,
    pageArrayRoot: string,
    isMissingTimeCoverage: boolean
  ) {
    const parts = this.statefulService.wrap(storageId, iterationId, pageIterationId).valueStringOnly.split('/');

    const iterationIdPrev = iterationId - 1;
    const partsPrev = this.statefulService.wrap(storageId, iterationIdPrev, pageIterationId).valueStringOnly.split('/');
    const monthPrev = +partsPrev.shift();
    const dayPrev = +partsPrev.shift();
    const yearPrev = +partsPrev.shift();

    const month = +parts.shift();
    const day = +parts.shift();
    const year = +parts.shift();
    const arrayValue = this.statefulService.wrap(storageId, currentSize - 1, pageIterationId);
    const containerPrev = currentSize > 1;

    if (!isMissingTimeCoverage && containerPrev && !this.isPast(`${month}/${day}/${year}`, `${monthPrev}/${dayPrev}/${yearPrev}`)) {
      if (this.isUpcoming(`${monthPrev}/${dayPrev}/${yearPrev}`, requiredYears)) {
        this.statefulService.arrayRemove(pageArrayRoot);
      }
    } else if (isMissingTimeCoverage && arrayValue != null) {
      this.statefulService.arrayAdd(pageArrayRoot);
    } else if (this.isUpcoming(`${monthPrev}/${dayPrev}/${yearPrev}`, requiredYears)) {
      this.statefulService.arrayRemove(pageArrayRoot);
    }
  }
  private resetDateValues(currentSize: number, requiredYears, pageIterationId: number, storageId: string, pageArrayRoot: string) {
    for (let i = 0; i < currentSize; i++) {
      const currentValue = this.statefulService.wrap(storageId, i, pageIterationId).valueString;
      if (this.isUpcoming(currentValue, requiredYears)) {
        for (let j = currentSize - 1; i < j; j--) {
          this.statefulService.arrayRemove(pageArrayRoot, j);
        }
        break;
      }
    }
  }

  private readonly isPast = (currentDate: string, pastDate: string): boolean => {
    const cDate = new Date(currentDate);
    const pDate = new Date(pastDate);
    return cDate <= pDate;
  };

  private readonly isUpcoming = (date: string, requiredYears): boolean => {
    const startDate = new Date(date);
    return Date.now() >= startDate.setFullYear(startDate.getFullYear() + +requiredYears);
  };

  /**
   * Check other fields
   */
  public checkOthersIfChecked = (context: LogicFnContext, ...fieldIds: string[]): void => {
    if (context.field?.data.value) {
      for (const fieldId of fieldIds) {
        const field = this.fieldService.createField(processPath(fieldId, context.field.pageIterationId), context.field.flowId);
        if (field) {
          field.data.value = true;
        }
      }
    }
  };

  /**
   * Set the value on a newly created item on an array
   * @param context logic fn field context
   * @param path storage id
   * @param ssPath optional storage to save field value
   */
  public createAndSetNext = (context: LogicFnContext, pathValue: string): void => {
    const value = context.field.data.value;
    const pageIterationId = context.field.pageIterationId;
    const path = processPath(pathValue, pageIterationId);
    const timeout = 0;
    if (value) {
      this.statefulService.arrayAdd(path, () => {
        // Invoking setTimeout with a callback, and zero as the second argument will schedule the callback
        // to be run asynchronously, after the shortest possible delay
        setTimeout(() => {
          const addedIndex = this.statefulService.arraySize(pathValue, pageIterationId) - 1;
          this.statefulService.wrap(pathValue, addedIndex, pageIterationId).value = value;
        }, timeout);
      });

      context.field.data.value = null;
      context.field.focused = false;

      this.setFocus(context);
    }
  };

  /**
   * Set focus on fields
   * @param context field context
   */
  public setFocus = (context: LogicFnContext): void => {
    if (context?.card) {
      this.handleADAAsset(context);
      this.handleADAEmployment(context);
      this.handleADALiability(context);
      this.handleADARealEstate(context);
    }
  };

  // ADA Asset
  private handleADAAsset(context) {
    if (context.card.id.includes('manual-asset-urla')) {
      if (context.card.id == `manual-asset-urla-0`) {
        this.focusService.focusElement(`add-asset-type-urla`);
      } else {
        this.focusService.focusElement(`more-asset-link-$`);
      }
    }
    if (context.card.id.includes(`manual-asset-co-borrower-urla`)) {
      if (context.card.id == `manual-asset-co-borrower-urla-${context.card.pageIterationId}-0`) {
        this.focusService.focusElement(`add-asset-type-co-borrower-urla-${context.card.pageIterationId}`);
      } else {
        this.focusService.focusElement(`more-asset-link-co-borrower-#-$`);
      }
    }
  }

  // ADA Employment
  private handleADAEmployment(context) {
    if (context.card.id.includes('manual-employment')) {
      if (context.card.id == `manual-employment-0`) {
        this.focusService.focusElement(`add-employment-type`);
      } else {
        this.focusService.focusElement(`employment-add-card-$`);
      }
    }

    if (context.card.id.includes('manual-employment-co-borrower')) {
      if (context.card.id == `manual-employment-co-borrower-${context.card.pageIterationId}-0`) {
        this.focusService.focusElement(`add-employment-type-co-borrower-${context.card.pageIterationId}`);
      } else {
        this.focusService.focusElement(`employment-add-card-co-borrower-#-$`);
      }
    }
  }

  // ADA Liablity
  private handleADALiability(context) {
    if (context.card.id.includes('manual-liability')) {
      if (context.card.id == `manual-liability-0`) {
        this.focusService.focusElement(`add-liability-type-urla`);
      } else {
        this.focusService.focusElement(`liability-add-card-$`);
      }

      if (context.card.id.includes('manual-liability-co-borrower')) {
        if (context.card.id == `manual-liability-co-borrower-${context.card.pageIterationId}-0`) {
          this.focusService.focusElement(`add-liability-type-co-borrower-urla-${context.card.pageIterationId}`);
        } else {
          this.focusService.focusElement(`liability-add-card-co-borrower-#-$`);
        }
      }
    }
  }

  // ADA Real Estate
  private handleADARealEstate(context) {
    if (context.card.id.includes(`property-details`)) {
      if (context.card.id.includes(`co-borrower`)) {
        this.focusService.focusElement(`property-add-card-co-borrower-#-$`);
      } else {
        this.focusService.focusElement(`property-add-card-$`);
      }
    }
  }

  /**
   * Unchecked other fields
   */
  public uncheckOthersIfChecked = (context: LogicFnContext, ...fieldIds: string[]): void => {
    if (context.field?.data.value) {
      for (const fieldId of fieldIds) {
        const targetField = this.fieldService.createField(
          fieldId,
          context.field.flowId,
          context.field.iterationId,
          context.field.pageIterationId
        );
        if (targetField?.config && targetField.config.type === 'checkbox') {
          this.fieldService.createField(processPath(fieldId, context.field.pageIterationId), context.field.flowId).data.value = false;
        } else {
          this.fieldService.createField(processPath(fieldId, context.field.pageIterationId), context.field.flowId).data.value = null;
        }
      }
    }
  };

  /**
   *  Uncheck other fields when unchecked
   */
  public uncheckOthersIfUnChecked = (context: LogicFnContext, ...fieldIds: string[]): void => {
    if (context.field && !context.field.data.value) {
      for (const fieldId of fieldIds) {
        this.fieldService.createField(processPath(fieldId, context.field.pageIterationId), context.field.flowId).data.value = false;
      }
    }
  };

  public lenderChange = (context: LogicFnContext, value: string, participantsList: PrimitiveType, targetPath: string): void => {
    const participantArray: string[] = participantsList ? participantsList.toString().split('/') : [];

    if (participantArray.length > 0) {
      const filterItems = (arr, query) => {
        return arr.filter((el) => el.indexOf(query) !== -1);
      };
      const Interviewer = filterItems(participantArray, value).toString();

      if (Interviewer.toString().split('-').length > 0) {
        this.statefulService.wrap(targetPath).value = Interviewer.toString().split('-')[1];
      }
    }
  };

  public updateMinimumArraySizeonSelection = (context: LogicFnContext, Option: string[], valuePath, size = 1): void => {
    const pageIterationId = context.card.pageIterationId;
    const arrayRoot = valuePath.split('/$')[0].split('$')[0];
    const currentSize = this.statefulService.arraySize(arrayRoot, pageIterationId);
    const selectedValue = currentSize > 0 ? this.statefulService.wrap(valuePath, 0, pageIterationId).valueStringOnly : undefined;
    if (selectedValue) {
      context.card.config.arrayMinimum = Option.includes(selectedValue) ? size : 1;
    }
  };

  public calculateDownPaymentDollar = (
    context: LogicFnContext,
    percentFieldId: string,
    dollarDownFieldId: string,
    purchasePrice: number
  ): void => {
    const percentField = this.fieldService.createField(percentFieldId, context.field.flowId);
    const dollarDownField = this.fieldService.createField(dollarDownFieldId, context.field.flowId);

    if (purchasePrice && dollarDownField && percentField?.dirty) {
      const percentDown = percentField.data.valueNumberOnly;

      // tslint:disable-next-line: no-magic-numbers
      dollarDownField.data.value = ((percentDown * purchasePrice) / 100).toFixed(0);
      dollarDownField.dirty = false;
    }
  };

  public calculateDownPaymentPercent = (
    context: LogicFnContext,
    dollarDownFieldId: string,
    percentFieldId: string,
    purchasePrice: number
  ): void => {
    const percentField = this.fieldService.createField(percentFieldId, context.field.flowId);
    const dollarDownField = this.fieldService.createField(dollarDownFieldId, context.field.flowId);

    if (purchasePrice && percentField && dollarDownField?.dirty) {
      const dollarDown = dollarDownField?.data.valueNumberOnly;

      // tslint:disable-next-line: no-magic-numbers
      percentField.data.value = (dollarDown / purchasePrice) * 100;
      percentField.dirty = false;
    }
  };

  public calculateDownPaymentDollarPercent = (
    context: LogicFnContext,
    dollarDownFieldId: string,
    percentFieldId: string,
    purchasePrice: number
  ): void => {
    const percentField = this.fieldService.createField(percentFieldId, context.field.flowId);
    const dollarDownField = this.fieldService.createField(dollarDownFieldId, context.field.flowId);
    const dollarDown = dollarDownField?.data.valueNumberOnly;

    if (percentField?.data.value) {
      // tslint:disable-next-line: no-magic-numbers
      percentField.data.value = (dollarDown / purchasePrice) * 100;
    }
  };

  /**
   * Add 1 item on specific option selected
   * If the filed value is equal to refOption, it will empty the array.
   * @param context field context
   * @param path storage path
   * @param refOption the reference option value to empty the array.
   */
  public addFirstItemOnOptionSelected = (context: LogicFnContext, pathValue: string, refOption: PrimitiveType): void => {
    const path = processPath(pathValue, context.field.pageIterationId);

    if (!this._flipCache[context.field.data.id] && context.field.data.value === refOption && this.statefulService.arraySize(path) === 0) {
      this._flipCache[context.field.data.id] = true;
      this.statefulService.arrayAdd(path, () => {
        this._flipCache[context.field.data.id] = false;
      });
    }
  };

  /**
   * Add 1 item on specific option selected
   * If the filed value is equal to refOption, it will empty the array.
   * @param context field context
   * @param path storage path
   * @param refOption the reference option value to empty the array.
   * @param callBackLogicFn callbackfunction refs
   */
  public addFirstItemOnOptionSelectedWithCallback = (
    context: LogicFnContext,
    pathValue: string,
    refOption: PrimitiveType,
    callBackLogicFn: LogicFnRef
  ): void => {
    const path = processPath(pathValue, context.field.pageIterationId);

    if (!this._flipCache[context.field.data.id] && context.field.data.value === refOption && this.statefulService.arraySize(path) === 0) {
      this._flipCache[context.field.data.id] = true;
      this.statefulService.arrayAdd(path, () => {
        this.logicservice.evaluate([callBackLogicFn], context);
        this._flipCache[context.field.data.id] = false;
      });
    }
  };

  /**
   * Add 1 item on specific option selected
   * If the filed value is equal to refOption, it will empty the array.
   * @param context field context
   * @param path storage path
   * @param yes value on true
   * @param no value on false
   */
  public arrayHasLengthSetValue = (context: LogicFnContext, path: string, yes: PrimitiveType, no: PrimitiveType): void => {
    context.field.data.value = this.statefulService.arraySize(path, context.field.pageIterationId) ? yes : no;
  };

  /**
   * Empty array based on specific selected option.
   * If the filed value is equal to refOption, it will empty the array.
   * @param context field context
   * @param path storage path
   * @param refOption the reference option value to empty the array.
   */
  public emptyArrayOnOptionSelected = (
    context: LogicFnContext,
    pathValue: string,
    refOption: PrimitiveType,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    jointFlagPath: string
  ): void => {
    const path = processPath(pathValue, context);
    if (!this._flipCache[context.field.data.id] && this.statefulService.arraySize(path) > 0 && context.field.data.value === refOption) {
      this._flipCache[context.field.data.id] = true;
      this.statefulService.arrayTruncate(path, () => {
        this._flipCache[context.field.data.id] = false;
      });
    }
  };

  /**
   * Set Parent parent id of all applicant when there is no joint applicant
   */
  public removeAllJointApplicant = (context: LogicFnContext): void => {
    if (!context.field.data.value) {
      new JointCreditManager(this.statefulService, PROTOCOL_MORTGAGE).removeAllJointCredit();
    }
  };

  /**
   * delete all item of array except first item based on specific selected option.
   * @param context field context
   * @param path storage path
   * @param Option the reference option value to empty the array.
   */
  public emptyArrayExceptFirstOnSelection = (context: LogicFnContext, path: string, Option: PrimitiveType, minimimMonths = 24): void => {
    if (context.field.data.value === Option) {
      const storageId = context.field.config.storageId;
      const pageIterationId = getPageIterationId(context);
      const arrayRoot = storageId.split('/$')[0].split('$')[0];
      const pageArrayRoot = processPath(arrayRoot, pageIterationId);
      const currentSize = this.statefulService.arraySize(arrayRoot, pageIterationId);
      for (let i = 1; i < currentSize; i++) {
        this.statefulService.arrayRemove(pageArrayRoot, i);
      }
      const employmentDuration = this.getEmploymentDuration(path, pageIterationId);
      if (employmentDuration < minimimMonths && employmentDuration > 0) {
        this.statefulService.arrayAdd(pageArrayRoot);
      }
    }
  };

  private readonly getEmploymentDuration = (storageIdSuffix: string, pageIterationId: number, iterationId = 0): number => {
    let totalDuration = 0;
    totalDuration += this.statefulService.wrap(storageIdSuffix + '/$/years', iterationId, pageIterationId).valueNumberOnly * 12;
    totalDuration += this.statefulService.wrap(storageIdSuffix + '/$/months', iterationId, pageIterationId).valueNumberOnly;
    return totalDuration;
  };

  /**
   * Remove item and update ownership interest field as needed
   * @param context Card context
   * @param targetFieldId field to reset if array is empty
   */
  public removeAndUpdateOwnership = (context: LogicFnContext, targetFieldId: string): void => {
    const pageArrayRoot = processPath(context.card.config.array, context);
    const targetField = processPath(targetFieldId, context);

    if (this.statefulService.arraySize(pageArrayRoot) === 1) {
      this.fieldService.createField(targetField, context.field.flowId).data.value = false;
    } else {
      this.statefulService.arrayRemove(pageArrayRoot);
    }
  };

  /**
   * Remove any duplicate place holders in the dropdown element.
   * @param context
   * @param dropDownList
   * @param removePlaceHolder
   * @param defaultPlaceholder
   * @param value
   */
  private readonly addNewDropdownDefault = (
    context: LogicFnContext,
    dropDownList: HTMLSelectElement,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    defaultPlaceHolder: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    value: string,
    removePlaceHolder: string
  ): void => {
    if (dropDownList) {
      for (const i in dropDownList.options) {
        if (dropDownList.options[i]) {
          if (String(dropDownList.options[i].innerText).toLowerCase() === removePlaceHolder.toLowerCase()) {
            dropDownList.options[i].remove();
          }
        }
      }
    }
  };

  /**
   * Create a new manual selectable placeholder for the dropdown element.
   * @param dropDownList
   * @param defaultPlaceHolder
   * @param value
   */
  private readonly addNewOption = (dropDownList: HTMLSelectElement, defaultPlaceHolder: string, value: string): void => {
    const option = document.createElement('option');
    option.text = defaultPlaceHolder;
    option.value = value;
    dropDownList.add(option, 0);
  };

  /**
   * Setup inital dropdown.  Override the default placeholder from the dictionary
   * and create your own selectable placeholder.
   * @param context
   * @param removePlaceHolder
   * @param defaultPlaceHolder
   * @param value
   */
  public loadDropdownDefault = (
    context: LogicFnContext,
    removePlaceHolder: string,
    defaultPlaceHolder: string,
    value: string = null
  ): void => {
    const dropDownList = document.getElementById(context.field.id) as HTMLSelectElement;
    this.addNewDropdownDefault(context, dropDownList, removePlaceHolder, defaultPlaceHolder, value);
    if (context.field.data.value as string) {
      this.addNewOption(dropDownList, defaultPlaceHolder, value);
    }
  };

  public loadPreferredBranchList = (
    context: LogicFnContext,
    removePlaceHolder: string,
    defaultPlaceHolder: string,
    value: string = null
  ): void => {
    const dropDownList = document.getElementById(context.field.id) as HTMLSelectElement;
    this.addNewDropdownDefault(context, dropDownList, removePlaceHolder, defaultPlaceHolder, value);
    const addNewOption = this.addNewOption;
    if (context.field.data.value as string) {
      this.loadBranch(context, 'loan-branch-list-dropdown', () => {
        // eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
        setTimeout(function () {
          addNewOption(dropDownList, defaultPlaceHolder, value);
        }, 0);
      });
    }

    dropDownList.onchange = () => {
      let defaultPresent = false;
      for (let i = 0; i < dropDownList.options.length; i++) {
        if (String(dropDownList.options[i].innerText).toLowerCase() === removePlaceHolder.toLowerCase()) {
          defaultPresent = true;
          if (i > 0) {
            dropDownList.options[i].remove();
          }
        }
      }
      if (!defaultPresent) {
        addNewOption(dropDownList, defaultPlaceHolder, value);
      }
    };
  };

  public setYesNoField = (context: LogicFnContext, storageId: string, setInverseValue: boolean = false): void => {
    const constValue = context.field.data.value;
    const value = constValue ? constValue.toString().toLowerCase() === 'yes' : null;
    this.statefulService.wrap(storageId).value = setInverseValue && context.field.data.value ? !value : value;
  };

  public loadYesNoField = (context: LogicFnContext, storageId: string, setInverseValue: boolean = false): void => {
    const value = this.statefulService.wrap(storageId).value;
    if (setInverseValue) {
      context.field.data.value = value == null ? '' : value ? 'No' : 'Yes';
    } else {
      context.field.data.value = value == null ? '' : value ? 'Yes' : 'No';
    }
  };

  public resetDeclarationExplanation = (context: LogicFnContext, pathValue: string): void => {
    if (context.field.data.value === false) {
      this.statefulService.wrap(processPath(pathValue, context.field.pageIterationId)).value = null;
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public resetDeclaration = (context: LogicFnContext): void => {
    const isOccupy = this.statefulService.wrap(`api:declarations/isOccupyPropertyasPrimaryResidence`);
    const isOwnership = this.statefulService.wrap(`api:declarations/isOwnershipInterestInLastThreeYears`);
    const propertyOwned = this.statefulService.wrap(`api:declarations/questionTypeOfPropertyOwned`);
    const holdProperty = this.statefulService.wrap(`api:declarations/questionHowDidYouHoldProperty`);

    if (isOccupy.value === false) {
      isOwnership.value = null;
      propertyOwned.value = null;
      holdProperty.value = null;
    } else if (isOwnership.value === false) {
      propertyOwned.value = null;
      holdProperty.value = null;
    }
  };

  public setFieldValue = (context: LogicFnContext, path: string): void => {
    this.statefulService.wrap(path).value = context.field.data.value;
    if (context?.field?.data && context.field.data.value != 'TwoToFourFamily') {
      this.statefulService.wrap('api:loan/propertyInformation/noOfUnits').value = null;
    }
  };

  /**
   * load branch users
   * TODO: Does this need to be window['_config']. Possible to use appConfig?
   */
  public loadBranchUsers = (context: LogicFnContext, branchId?: string): void => {
    /* Prevent loading the branchUser APi,
       if consecutive requests come in at the same time
       If the loan participant list already exists
       If the path is postapp or the path is null
     */
    branchId = !branchId ? '' : branchId;
    if ((window['_config']?.lender && !window['_config'].lender.isMortgageAvailable) || String(this.location.path()) === '/null') {
      return;
    }

    this.branchUserLoading = true;
    const branchUsersStateful = this.statefulService.wrap('mem:branch-users');
    branchUsersStateful.value = '[]';
    this.statefulService.wrap('mem:show-card-spinner').value = true;
    this.applicationApiService.branchUserList(Info.interviewer, branchId, (error, data) => {
      const branchUsers = [];
      if (!error) {
        let participants = '';
        data.forEach((element) => {
          branchUsers.push({
            firstName: element.firstName,
            lastName: element.lastName,
            userId: element.userId
          });
          const selectedRole =
            element.roles && element.roles.length > 0
              ? element.roles.indexOf(Info.loanOfficer) >= 0
                ? Info.loanOfficer
                : element.roles[0]
              : '';
          participants += `${element.userId}-${selectedRole}/`;
        });
        this.branchUserLoading = false;
        this.statefulService.wrap('mem:show-card-spinner').value = false;
        this.statefulService.wrap('mem:loan-participant-list').value = participants;
      } else {
        this.statefulService.wrap('mem:show-card-spinner').value = false;
      }
      branchUsersStateful.value = JSON.stringify(branchUsers);
    });
  };

  /** On Branches Changes */
  public onChangeOAOBranch = (context: LogicFnContext): void => {
    const branch = context.field.enum.find((i) => i.value === context.field.data.value);
    if (branch?.label) {
      this.statefulService.wrap('api:oaoMemberInformation/preferredBankBranch/branchName').value = branch.label;
    }
  };
  /** On referral source Changes */
  public onChangeReferralSource = (_context: LogicFnContext): void => {
    const source: any = _context.field.enum.find((i) => i.value.toString() === _context.field.data.value.toString());
    if (source?.label) {
      this.statefulService.wrap('api:oaoMemberInformation/referralSource/id').value = source.id;
    }
  };
  /**
   * Load OAO Membership Names
   * @param targetFieldId - ID of Enum
   */
  public loadOAOMembership = (context: LogicFnContext, targetFieldId: string): void => {
    const targetField = this.fieldService.createField(targetFieldId, context.field.flowId);

    // Only call the API when the enum is not loaded. Once enum loaded here, then it will not make api call
    if (targetField?.enum?.length === 0) {
      this.statefulService.wrap('mem:show-card-spinner').value = true;
      this.l360ApiService.getMemberships().subscribe({
        next: (response: any) => {
          if (response?.data?.memberships) {
            const memberships = response.data.memberships.filter(
              (membership) =>
                membership.membershipTypeName.toString().toLowerCase() === 'personal' ||
                membership.membershipTypeName.toString().toLowerCase() === 'business'
            );

            const membershipId = response.data.organizationID ? response.data.organizationID : 0;
            this.statefulService.wrap('api:oaoMemberInformation/membership/organizationID').value = Number(membershipId);
            let enumvalue;
            memberships.forEach((element) => {
              enumvalue = {
                enumId: element.membershipTypeName,
                isYouth: element.membershipTypeName?.toLowerCase() === 'personal' && element.isYouth,
                label: element.membershipName,
                maxAge: element.maxAge,
                description: element.description,
                redirectURL: element.redirectURL,
                membershipFee: element.membershipFee,
                minAge: element.minAge,
                value: element.membershipID?.toString(),
                virtual: false,
                isPromoCode: element.maxPromoCodeDisplay,
                isHideMembershipSelection: element.isHideMembershipSelection
              };
              targetField.enum.push(enumvalue);
            });
            // targetField.enum. = enumValue;
            memberships.sort((a, b) => a.membershipName.localeCompare(b.membershipName));
            targetField.enum.sort((a, b) => a.label.localeCompare(b.label));
          }
          context.field.data.value = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipID').value;
          this.setMembershipTypeToMemStorage(context);
          this.statefulService.wrap('mem:show-card-spinner').value = false;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        error: () => {
          this.statefulService.wrap('mem:show-card-spinner').value = false;
        }
      });
    } else {
      context.field.data.value = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipID').value;
      this.setMembershipTypeToMemStorage(context);
    }
  };

  /**
   * Set default lenderid if user selects no from referral.
   * @param context
   */
  public setDefaultBranchId = (context: LogicFnContext, path: string): void => {
    if (this.lenderService.lenderData && this.lenderService.lenderData.originatingBranchId && context.field.data.value == false) {
      this.statefulService.wrap(path).value = this.lenderService.lenderData.originatingBranchId;
    }
  };

  // eslint-disable-next-line @typescript-eslint/ban-types
  public loadBranch = (context: LogicFnContext, targetFieldId: string, cb?: Function): void => {
    const targetField = this.fieldService.createField(targetFieldId, context.field.flowId);
    // Only call the API when the enum is not loaded. Once enum loaded here, then it will not make api call
    if (targetField?.enum?.length > 0) {
      targetField.data.value = '';
      return;
    }
    this.statefulService.wrap('mem:show-card-spinner').value = true;
    this.addFieldtoRequestList(context.field.id);
    this.applicationApiService.branchList((error, response) => {
      if (!error && response) {
        let enumvalue;
        response.forEach((element) => {
          enumvalue = {
            enumId: targetField.id,
            label: element.branchName,
            value: element.branchId,
            virtual: false
          };
          targetField.enum.push(enumvalue);
        });
        let requestList = this.parseStringToarray(this.statefulService.wrap('mem:requestList').valueStringOnly);
        requestList = requestList.filter((f) => f !== context.field.id);
        this.statefulService.wrap('mem:requestList').value = JSON.stringify(requestList);
        this.statefulService.wrap('mem:show-card-spinner').value = false;
      } else {
        this.statefulService.wrap('mem:show-card-spinner').value = false;
      }

      if (cb) {
        cb('Loaded');
      }
    });
  };

  /**
   * On Load of Membership page changing continue text according to user login
   * @param context Current Field context
   */
  public membershipPageNextBtnTextChanges = (context: LogicFnContext): void => {
    if (context?.page?.config) {
      if (this.userService?.isAuthenticated) {
        context.page.config.next = 'Continue application';
      }
    }
  };

  public onChangeMembership = (context: LogicFnContext): void => {
    /** Set value in memory to stored value in API */
    this.setMembershipTypeToMemStorage(context);
    this.oaoMembershipSelectionContext = context;
  };

  public setMembershipTypeToMemStorage = (context: LogicFnContext): void => {
    const field = context.field;
    if (
      field.config.payload?.['dropdownLists'] &&
      (field.config.payload['dropdownLists'] as any).length > 0 &&
      context?.field?.data?.value
    ) {
      const memberships = JSON.parse(field.config.payload['dropdownLists'] as string);
      if (!memberships || memberships.length == 0) {
        return;
      }

      const member = memberships.filter((i) => i.value.toString() === context.field.data.value.toString());
      if (member?.length > 0) {
        this.statefulService.wrap('mem:oaoMemberInformation/membership/membershipID').value = member[0].value ? member[0].value : '';
        this.statefulService.wrap('mem:oaoMemberInformation/membership/membershipType').value = member[0].enumId ? member[0].enumId : null;
        this.statefulService.wrap('mem:oaoMemberInformation/membership/isYouth').value = member[0].isYouth;
        this.statefulService.wrap('mem:oaoMemberInformation/membership/description').value = member[0].description;
        this.statefulService.wrap('ss:oaoMemberInformation/membership/isEnabledChecklist').value = member[0].isEnabledChecklist;
        this.statefulService.wrap('ss:oaoMemberInformation/membership/checklistdescription').value = member[0].checklistDescription;
        this.statefulService.wrap('mem:oaoMemberInformation/membership/redirectURL').value = member[0].redirectURL;
        this.statefulService.wrap('mem:oaoMemberInformation/membership/isPromoCode').value = member[0].isPromoCode;

        const flow = this.flowService.createFlow(member[0].redirectURL);
        const eligiblity = flow.allPages.find((t) => t.id === 'oao-eligibility');
        this.statefulService.wrap('api:skipEligibility').value = !(eligiblity?.visible || false);
      }
    }
  };

  /** Membership change patches */
  public patchMembership = (context: LogicFnContext): void => {
    const bundleMembershipId = this.statefulService.wrap('mem:oaoMemberInformation/membership/membershipID').value;
    const dropdownMembershipId = this.statefulService.wrap('ss:oaoMemberInformation/membership/dropdownMembershipID').value;
    const memberTypeID = bundleMembershipId || dropdownMembershipId;
    const field = context.field;

    if (field.config.payload?.dropdownLists && (field.config.payload?.dropdownLists as any).length > 0 && memberTypeID) {
      const memberships = JSON.parse(field.config.payload.dropdownLists as string);
      if (!memberships || memberships.length == 0) {
        return;
      }

      const member = memberships.filter((i) => i.value.toString() === memberTypeID.toString());
      if (member?.length > 0) {
        this.statefulService.wrap('api:oaoMemberInformation/membership/membershipID').value = member[0].value ? member[0].value : '';
        this.statefulService.wrap('api:oaoMemberInformation/membership/minAge').value = this.getMinMaxAge(member[0].minAge);
        this.statefulService.wrap('api:oaoMemberInformation/membership/maxAge').value = this.getMinMaxAge(member[0].maxAge);
        this.statefulService.wrap('api:oaoMemberInformation/membership/membershipName').value = member[0].label ? member[0].label : '';
        this.statefulService.wrap('api:oaoMemberInformation/membership/redirectURL').value = member[0].redirectURL;
        this.statefulService.wrap('api:oaoMemberInformation/membership/membershipFee').value = member[0].membershipFee;
        this.statefulService.wrap('api:oaoMemberInformation/membership/membershipTypeName').value = member[0].enumId
          ? member[0].enumId
          : null;
        this.statefulService.wrap('api:oaoMemberInformation/membership/isYouth').value = member[0].isYouth;
        this.statefulService.wrap(`api:oaoMemberInformation/hasCoApplicant`).value = member[0].isYouth ? Boolean(member[0].isYouth) : null;

        const flow = this.flowService.createFlow(member[0].redirectURL);
        const eligiblity = flow.allPages.find((t) => t.id === 'oao-eligibility');
        this.statefulService.wrap('api:skipEligibility').value = !(eligiblity?.visible || false);
      }
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private readonly getMinMaxAge = (value: string): number | string => {
    return value ?? null;
  };

  /** Clearing all OAO Application shares and Precise Id fields */
  public clearOAOApplicationFields = (): void => {
    const applicationId = this.statefulService.wrap('api:oaoMemberInformation/accountsAndServices/applicationId').value;
    if (applicationId) {
      /** Clearing Application,Applicant and Shares section */
      this.statefulService.wrap('api:oaoMemberInformation/accountsAndServices/applicationId').value = null;
      this.statefulService.wrap('api:oaoMemberInformation/accountsAndServices/primaryApplicant/applicantId').value = null;
      this.statefulService.wrap('ss:oao-accounts-and-services').value = null;
      this.statefulService.wrap('mem:oao-accounts-and-services').value = null;
      this.statefulService.wrap('mem:accounts-and-services').value = null;
      this.statefulService.wrap('mem:oao-identity-verification-question').value = null;
      this.statefulService.arrayTruncate('api:oaoMemberInformation/accountsAndServices/primaryApplicant/shares');

      /** Clearing Precise ID section */
      this.statefulService.wrap('ss:oaoMemberInformation/identityVerificationQuestions').value = null;
      this.statefulService.wrap('api:oaoMemberInformation/userIdentity/correlationId').value = null;
      this.statefulService.wrap('api:oaoMemberInformation/userIdentity/preciseIdFinalScore').value = null;
      this.statefulService.wrap('api:oaoMemberInformation/userIdentity/preciseIdFinalDecision').value = null;
      this.statefulService.wrap('api:oaoMemberInformation/isIdentityVerificationCompleted').value = null;
    }

    /** clear instatouch option */
    // this.statefulService.wrap('api:oaoMemberInformation/primaryApplicant/autoFillOption').value = null;
    // this.statefulService.wrap('api:oaoMemberInformation/coApplicant/autoFillOption').value = null;
    // this.statefulService.wrap('api:oaoMemberInformation/additionalCoApplicant/autoFillOption').value = null;

    /** Clear Additional Questions */
    this.statefulService.arrayTruncate('api:oaoMemberInformation/customField/applicationCustomFields');

    // ReValidate All pages since membership get changed.
    this.statefulService.wrap('mem:ValidateAllPages').load();
  };

  /**
   * Set co applicant flag to trigger creation of coApplicant in bundle
   * @param context field context
   */
  public setCoApplicant = (context: LogicFnContext): void => {
    this.statefulService.wrap('api:borrowerInfo/questionIsApplyingwithSpouse').value = context.field?.data?.value as boolean;
    if (context.field.data.value && this.statefulService.arraySize(coBorrowersPath(PROTOCOL_MORTGAGE)) === 0) {
      this.statefulService.arrayAdd(coBorrowersPath(PROTOCOL_MORTGAGE));
    }
  };

  /**
   * OAO ONLY
   * Remove additional co-applicant if co-app is empty
   */
  public removeAdditionalCoApp = (context: LogicFnContext): void => {
    const storageId = 'api:oaoMemberInformation/hasAdditionalCoApplicant';
    if (!context.field.data.value && storageId && this.statefulService.wrap(storageId).value) {
      this.statefulService.wrap(storageId).value = false;
    }
    if (!this.visibleFunctionsService.visibleIsOAOInstatouchEnabled()) {
      this.statefulService.wrap('api:oaoMemberInformation/coApplicant/autoFillOption').value = 'Manual';
      this.statefulService.wrap('api:oaoMemberInformation/coApplicant/isPrefilled').value = false;
      this.statefulService.wrap('mem:primary-application-status-co-applicant').value = true;
    }
    this.l360ApiService.clearDisclosure();
  };

  /**
   * OAO ONLY
   * Remove both coApplicant and additionalCoApplicant
   */
  public removeCoApplicants = (context: LogicFnContext): void => {
    this.removeAdditionalCoApp(context);
    this.oaoPageHelper.deleteOaoApplicant('api:oaoMemberInformation/coApplicant');
  };

  /**
   * Set field value when array is truncated
   * @param context field context
   * @param arrayPath array is empty triggered
   * @param storageId field storageId
   * @param value primitive type value
   */
  public setValueOnEmptyArray = (context: LogicFnContext, arrayPath: string, storageId: string, value: PrimitiveType): void => {
    if (this.statefulService.arraySize(arrayPath) === 0) {
      this.statefulService.wrap(storageId).value = value;
    }
  };

  /**
   * Sets the storageId's value based on whether or not a checkbox is checked or unchecked.
   * @param context checkbox context
   * @param storageId stateful value to set.
   * @param newValue the value to set if the checkbox is checked.
   * @param falseValue the value to set if the checkbox is un-checked.
   */
  public setValueIfCheckboxClicked = (
    context: LogicFnContext,
    storageId: string,
    newValue: PrimitiveType,
    falseValue: PrimitiveType
  ): void => {
    const iterationId = 0;
    if (!context.field.data.value && !context.field.data.isChanged) {
      this.statefulService.wrap(storageId, iterationId).value = newValue;
    } else {
      this.statefulService.wrap(storageId, iterationId).value = falseValue;
    }
  };

  /**
   * Sets the storageId's value based on whether or not a checkbox is checked or unchecked for specific item based on iteration id.
   * @param context checkbox context
   * @param storageId stateful value to set.
   * @param newValue the value to set if the checkbox is checked.
   * @param falseValue the value to set if the checkbox is un-checked.
   */
  public setValueForCurrentIterationIfCheckboxClicked = (
    context: LogicFnContext,
    storageId: string,
    primaryApplicantStorageId: string,
    bussinfoPrimaryStorageId: string,
    falseValue: PrimitiveType
  ): void => {
    const membershipTypeName = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipTypeName').valueString;

    if (membershipTypeName?.toLowerCase() === 'business') {
      this.statefulService.wrap(storageId, context.field.iterationId).value =
        !context.field.data.value && !context.field.data.isChanged ? this.statefulService.wrap(bussinfoPrimaryStorageId).value : falseValue;
    } else {
      this.statefulService.wrap(storageId, context.field.iterationId).value =
        !context.field.data.value && !context.field.data.isChanged
          ? this.statefulService.wrap(primaryApplicantStorageId).value
          : falseValue;
    }
  };

  public GetCurrentFieldId = (context: LogicFnContext): void => {
    this.statefulService.wrap('mem:current-field-id').value = context.field.id;
  };

  public setDefaultLoanType = (context: LogicFnContext): void => {
    if (context.field.enum.length === 1 && !context.field.data.value) {
      context.field.data.value = context.field.enum[0].value;
    }
  };

  public preSelectRadio = (context: LogicFnContext, storageId: string): void => {
    this.statefulService.wrap(storageId, 0, context.field.pageIterationId).value = context.field.data.value === true ? false : null;
  };

  public resetMilitaryStatus = (context: LogicFnContext): void => {
    const militaryMapping = processPath(`api:${coAppSwitch(context)}borrowerInfo/militaryServiceType`, context);
    if (context?.field.data.value === false) {
      this.statefulService.wrap(militaryMapping).value = null;
    }
  };

  public resetActiveDuty = (context: LogicFnContext): void => {
    if (context?.field.data.value !== true) {
      context.field.dirty = false;
    }
  };

  public showPrimaryApplicant = (context: LogicFnContext): void => {
    this.statefulService.wrap('mem:primary-application-status').value = !!(
      context.field.data.value && context.field.data.value === 'Manual'
    );
  };

  public showPrimaryCoApplicant = (context: LogicFnContext): void => {
    this.statefulService.wrap('mem:primary-application-status-co-applicant').value = !!(
      context.field.data.value && context.field.data.value === 'Manual'
    );
  };

  public showPrimaryAdditionalCoApplicant = (context: LogicFnContext): void => {
    this.statefulService.wrap('mem:primary-application-status-additional-co-app').value = !!(
      context.field.data.value && context.field.data.value === 'Manual'
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public hidePrimaryApplicationCard = (context: LogicFnContext): void => {
    const autoFillOption = this.statefulService.wrap(`api:oaoMemberInformation/primaryApplicant/autoFillOption`).value;
    if (autoFillOption && autoFillOption !== '') {
      this.statefulService.wrap('mem:primary-application-status').value = autoFillOption === 'Manual';
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public hidePrimaryCoApplicationCard = (context: LogicFnContext): void => {
    const autoFillOption = this.statefulService.wrap(`api:oaoMemberInformation/coApplicant/autoFillOption`).value;
    if (autoFillOption && autoFillOption !== '') {
      this.statefulService.wrap('mem:primary-application-status-co-applicant').value = autoFillOption === 'Manual';
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public hidePrimaryAdditionalCoApplicationCard = (context: LogicFnContext): void => {
    const autoFillOption = this.statefulService.wrap(`api:oaoMemberInformation/additionalCoApplicant/autoFillOption`).value;
    if (autoFillOption && autoFillOption !== '') {
      this.statefulService.wrap('mem:primary-application-status-additional-co-app').value = autoFillOption === 'Manual';
    }
  };

  public dynamicTitle = (context: LogicFnContext, prefix: string, ...values: string[]): string => {
    const jointValues = values ? values.join(' ') : '';
    const title = prefix ? prefix.replace('?', jointValues) : jointValues;
    const pageId = `${context.page.pageIterationId === undefined ? '' : context.page.pageIterationId + 1}`;
    const defaultTitle = context.page.config.title?.includes('#')
      ? `${context.page.config.title.replace('#', pageId)}`
      : `${context.page.config.title} ${pageId}`;
    return jointValues.trim() && title.trim() ? title : defaultTitle;
  };

  public dynamicReviewTitle = (context: LogicFnContext, reviewTitle: string): string => {
    const optionalReviewPages = context.page.hideOptionalReviewPages;
    if (optionalReviewPages) {
      return reviewTitle;
    }
    return context.page.config.title;
  };

  public textWhenHasData = (context: LogicFnContext, trueText: string, falseText?: string): string => {
    const isPrefilled =
      this.userService?.flowType?.toLowerCase() == 'oao'
        ? this.statefulService.wrap('api:oaoMemberInformation/primaryApplicant/isPrefilled').value
        : this.statefulService.wrap('ola:borrowerInfo/isPrefilled').value;
    if (isPrefilled || this.platformLocation?.hash.length) {
      return trueText;
    }
    return falseText || null;
  };

  public dynamicLabel = (context: LogicFnContext, prefix: string, ...values: string[]): string => {
    const jointValues = values ? values.join(' ') : '';
    const label = prefix ? prefix.replace('?', jointValues) : jointValues;
    const defaultLabel = `${context.field.config.label}`;
    return jointValues.trim() && label.trim() ? label : defaultLabel;
  };

  public dynamicPageTitle = (context: LogicFnContext, prefix: string, hasCoApplicant: boolean, ...values: string[]): string => {
    const jointValues = values ? values.join(' ') : '';
    const title = prefix ? prefix.replace('?', jointValues) : jointValues;
    const defaultTitle = `${context.page.config.title}${
      context.page.pageIterationId === undefined ? '' : context.page.pageIterationId + 1
    }`;

    // Membership Type 1. Personal = 1, 2. Youth = 2, 3. Business = 3,
    const membershipTypeName = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipTypeName').valueString;
    if (membershipTypeName?.toLowerCase() == 'business') {
      return jointValues.trim() && title.trim() ? title : defaultTitle;
    } else {
      hasCoApplicant = this.statefulService.wrap('api:oaoMemberInformation/hasCoApplicant').value as boolean;
    }

    return jointValues.trim() && title.trim() && hasCoApplicant ? title : defaultTitle;
  };

  public coApplicantCardTitle = (context: LogicFnContext): string => {
    return `${context.card.config.title} ${context.card.iterationId + 1}`;
  };

  public dynamicCardTitle = (context: LogicFnContext, prefix: any, ...values: string[]): string => {
    const captilizedString = values ? values.map((v) => v?.replace(/^./, v[0] && v[0].toUpperCase())) : undefined;
    const jointValues = captilizedString ? captilizedString.join(' ') : '';
    let title = '';
    const pageiterationId = getPageIterationId(context);
    if (prefix && Array.isArray(prefix) && prefix.length > 0) {
      const index = prefix.length > context.card.iterationId ? context.card.iterationId : 1;
      title = `${prefix[index]}`;
      if (context.card.config.array && this.statefulService.arraySize(context.card.config.array, pageiterationId) > 2) {
        title =
          (title ? title.replace('?', jointValues) : jointValues) + (context.card.iterationId >= 1 ? ` — ${context.card.iterationId}` : '');
      } else if (context.card.config.array && this.statefulService.arraySize(context.card.config.array, pageiterationId) <= 2) {
        title = title ? title.replace('?', jointValues) : jointValues;
      }
    } else {
      title = prefix ? prefix.replace('?', jointValues) : jointValues;
    }
    let defaultTitle = `${context.card.config.title}${context.card.pageIterationId === undefined ? '' : context.card.pageIterationId + 1}`;
    if (context.card.config.title && Array.isArray(context.card.config.title) && context.card.config.title.length > 0) {
      const index = context.card.config.title.length > context.card.iterationId ? context.card.iterationId : 1;
      if (context.card.config.array && this.statefulService.arraySize(context.card.config.array, pageiterationId) > 2) {
        defaultTitle = `${context.card.config.title[index]}` + (context.card.iterationId >= 1 ? ` — ${context.card.iterationId}` : '');
      } else if (context.card.config.array && this.statefulService.arraySize(context.card.config.array, pageiterationId) <= 2) {
        defaultTitle = `${context.card.config.title[index]}`;
      }
    }
    // Membership Type 1. Personal = 1, 2. Youth = 2, 3. Business = 3,
    let hasCoApplicant = false;
    const membershipTypeName = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipTypeName').valueString;
    if (membershipTypeName && membershipTypeName.toLowerCase() == 'business') {
      return jointValues.trim() && title.trim() ? title : defaultTitle;
    } else {
      hasCoApplicant = this.statefulService.wrap('api:oaoMemberInformation/hasCoApplicant').value as boolean;
    }

    return jointValues.trim() && title.trim() && hasCoApplicant ? title : defaultTitle;
  };
  /** calculateDefaultAllocation() */
  public calculateDefaultAllocation = (): void => {
    this.oaoPageHelper.calculateDefaultAllocation();
  };

  public showLoanOfficer = (context: LogicFnContext): boolean => {
    if (context?.field?.enum?.length > 0) {
      return true;
    }
  };

  /**
   * Load Responsible list for business
   *   * @param arrayPath - Path of respective business array
   */
  /** To load Responsible,Additional Reponsible and Authorized card List */
  public onChangeBusinessDropdownList = (context: LogicFnContext, arrayPath: string): void => {
    const selectedValue = this.contextCheck(context) ? context.field.data.valueNumber : 0;
    const prevArrayCount = this.statefulService.arraySize(arrayPath);
    if (selectedValue > prevArrayCount) {
      for (let i = prevArrayCount; i < selectedValue; i++) {
        this.statefulService.arrayAdd(arrayPath, () => {
          if (context.field.id.toLowerCase() != BUSINESS_RESPONSIBLE_ID && i != 0) {
            this.statefulService.wrap(`${arrayPath}/$/${FIRSTNAME}`, i).value = '';
            this.statefulService.wrap(`${arrayPath}/$/${LASTNAME}`, i).value = '';
            this.statefulService.wrap(`${arrayPath}/$/${ISRESPONSIBLITY}`, i).value = false;
            this.statefulService.wrap(`${arrayPath}/$/${PERCENTAGE}`, i).value = '';
          } else if (context.field.id.toLowerCase() == BUSINESS_RESPONSIBLE_ID && i == 0) {
            this.onChangeResponsiblePartiesDDL(context, arrayPath);
          }
          if (!this.visibleFunctionsService.visibleIsOAOInstatouchEnabled()) {
            this.statefulService.wrap(`${arrayPath}/${i}/${AUTOFILLOPTION}`).value = 'Manual';
            this.statefulService.wrap(`mem:primary-application-status`).value = true;
          } else {
            this.statefulService.wrap(`${arrayPath}/${i}/${AUTOFILLOPTION}`).value = null;
            this.statefulService.wrap(`mem:primary-application-status`).value = null;
          }
          this.refreshNavigation();
        });
      }
    } else {
      for (let i = prevArrayCount - 1; i >= selectedValue; i--) {
        this.statefulService.arrayRemove(arrayPath, i, () => {
          if (i === selectedValue && context?.field?.id?.toLowerCase() === BUSINESS_RESPONSIBLE_ID) {
            this.loadAdditionalBeneficaryList(context, BUSINESS_ADDITIONAL_ID);
          }
          this.refreshNavigation();
        });
      }
    }
  };
  /**
   * Load Additional Beneficary list for business
   *   * @param targetFieldId - ID of Enum
   */
  public loadAdditionalBeneficaryList = (context: LogicFnContext, targetFieldId: string, oaoPercentageFieldId?: string): void => {
    const targetField = this.fieldService.createField(targetFieldId, context.field.flowId);
    const responsibleCardSize = this.statefulService.arraySize(RESPONSIBLE_PARTIES);
    const maxCount = 4;
    if (!this.contextCheck(context) && oaoPercentageFieldId && context.field.iterationId) {
      this.statefulService.wrap(oaoPercentageFieldId, context.field.iterationId).value = null;
    }
    let selectedYesCount = 0;
    for (let i = 0; i < responsibleCardSize; i++) {
      if (this.statefulService.wrap(RESPONSIBLE_PARTIES_ISPARTY, i).value === true) {
        selectedYesCount++;
      }
    }
    const condition = maxCount - selectedYesCount;
    let enumvalue;
    while (targetField?.enum?.length > 0) {
      targetField.enum.pop();
    }
    const lastSelectedValue = this.statefulService.wrap(ADDITIONAL_BENEFICIAL_COUNT).valueNumber;
    if (condition > 0) {
      for (let i = 1; i <= condition; i++) {
        enumvalue = {
          enumId: i,
          label: i,
          value: i,
          virtual: false
        };
        targetField.enum.push(enumvalue);
      }
      if (lastSelectedValue > condition) {
        this.statefulService.wrap(ADDITIONAL_BENEFICIAL_COUNT).value = condition;
      }
    }
  };

  /** Method to Clear List for Business template */
  public clearBusinessListArray = (context: LogicFnContext, arrayPath: string, setEmptyValueStorageId: string): void => {
    const arraySize = this.statefulService.arraySize(arrayPath);
    if (!this.contextCheck(context) && arraySize > 0) {
      // this.statefulService.arrayTruncate(arrayPath);
      this.statefulService.wrap(setEmptyValueStorageId).value = '';
    }
  };

  private readonly refreshNavigation = (): void => {
    this.pageStateService.refreshPageState();
  };

  /** Method to remove Trailing Spaces */
  public removeTrailingSpaces = (context: LogicFnContext): void => {
    if (context.field?.data.value) {
      context.field.data.value = context.field.data.value.toString().trim();
    }
  };

  private readonly contextCheck = (context: LogicFnContext): boolean => {
    return !!context?.field?.data?.value;
  };

  /**
   * Centralized logging method to handle both ApplicationInsights and SawDust logging
   * @param eventName The name of the event to log
   * @param eventData The data to include with the event
   */
  private logEvent(eventName: string, eventData: Record<string, unknown>): void {
    this.applicationInsightsService.logEvent(eventName, eventData);
    this.logger.logEvent(eventName, eventData);
  }

  /**
   * Load PickListItems
   *   * @param targetFieldId - ID of Enum
   */
  public loadPrimaryBusinessClassification = (context: LogicFnContext, businessClass: string): void => {
    const targetField = this.fieldService.createField(context.field.id, context.field.flowId);
    // Only call the API when the enum is not loaded. Once enum loaded here, then it will not make api call
    if (targetField?.enum?.length == 0) {
      const selectedValue = targetField.data.value;
      targetField.data.value = null;

      const eventPairId = genTinyGUID(24); // TODO: Replace this with cypto.randomUUID() when TS is updated
      const logSrc = 'workflow';
      this.logEvent('ecp.ui.picklist', {
        eventState: 'start',
        correlationId: eventPairId,
        source: logSrc,
        keys: businessClass
      });

      const picklistTypes = this.l360ApiService.getPickListTypes(businessClass);
      if (picklistTypes?.length > 0) {
        let enumvalue;
        targetField.enum.length = 0;
        // tslint:disable-next-line: max-line-length
        picklistTypes[0].pickListItems.forEach((element) => {
          enumvalue = {
            enumId: element.id,
            label: element.value,
            value: element.id,
            virtual: false
          };
          targetField.enum.push(enumvalue);
        });

        setTimeout(() => {
          targetField.data.value = selectedValue === 0 ? null : selectedValue;
        }, 300);

        // REMOVE IN 218336
        this.logEvent('ecp.ui.picklist', {
          eventState: 'end',
          correlationId: eventPairId,
          source: logSrc
        });
      }
    }
  };

  /**
   * Load OAO Employment Status
   * @param targetFieldId - ID of Enum
   */
  public oaoReferralSourceEnumBuilder = (context: LogicFnContext): ValueLabelItem[] => {
    const field = context.field;
    const membershipId = this.getMembershipId();

    if (!field.config.payload) {
      field.config.payload = {};
    }

    if (field.config.payload.membershipId != membershipId) {
      field.config.payload = {};
      field.config.payload.membershipId = membershipId;
    }

    if (
      field.config.payload.isLoading ||
      (field.config.payload['dropdownLists'] && (field.config.payload['dropdownLists'] as any).length > 0)
    ) {
      const dropdownValues = field.config.payload['dropdownLists']
        ? (JSON.parse(field.config.payload['dropdownLists'] as string) as ValueLabelItem[])
        : [];
      return dropdownValues;
    }
    field.config.payload.isLoading = true;

    const referralsources = this.adminPortalFeaturesService.config?.referralSources;
    if (referralsources) {
      const dropdownValues = referralsources;
      if (!dropdownValues) {
        return;
      }
      const list = Array.from(new Set(dropdownValues)).map((item: any) => {
        return { ...buildEnumItem(item.name), id: item.id };
      });
      field.config.payload['dropdownLists'] = JSON.stringify(list);
      field.config.payload.isLoading = false;
      return list;
    }

    return [];
  };

  /**
   * Load OAO Employment Status
   * @param targetFieldId - ID of Enum
   */
  public oaoPreferredBranchEnumBuilder = (context: LogicFnContext): ValueLabelItem[] => {
    const field = context.field;
    const membershipId = this.getMembershipId();

    if (!field.config.payload) {
      field.config.payload = {};
    }

    if (field.config.payload.membershipId != membershipId) {
      field.config.payload = {};
      field.config.payload.membershipId = membershipId;
    }

    if (
      field.config.payload.isLoading ||
      (field.config.payload['dropdownLists'] && (field.config.payload['dropdownLists'] as any).length > 0)
    ) {
      const dropdownValues = field.config.payload['dropdownLists']
        ? (JSON.parse(field.config.payload['dropdownLists'] as string) as ValueLabelItem[])
        : [];
      return dropdownValues;
    }
    field.config.payload.isLoading = true;

    const preferredBankBranch = this.adminPortalFeaturesService.config?.preferredBranches;
    if (preferredBankBranch) {
      const dropdownValues = preferredBankBranch;
      if (!dropdownValues || dropdownValues.length <= 0) {
        this.statefulService.wrap('api:oaoMemberInformation/showPreferredbankbranches').value = false;
        return;
      }
      const list = Array.from(new Set(dropdownValues)).map((item: any) => buildEnumItem(item.id, item.name));
      field.config.payload['dropdownLists'] = JSON.stringify(list);
      this.statefulService.wrap('api:oaoMemberInformation/showPreferredbankbranches').value = true;
      field.config.payload.isLoading = false;
      return list;
    }

    return [];
  };

  /**
   * Load Organization Types
   * @param targetFieldId - ID of Enum
   */
  public oaoOrganizationTypesEnumBuilder = (context: LogicFnContext): ValueLabelItem[] => {
    const field = context.field;

    if (!field.config.payload) {
      field.config.payload = {};
    }

    if (
      field.config.payload.isLoading ||
      (field.config.payload['dropdownLists'] && (field.config.payload['dropdownLists'] as any).length > 0)
    ) {
      const dropdownValues = field.config.payload['dropdownLists']
        ? (JSON.parse(field.config.payload['dropdownLists'] as string) as ValueLabelItem[])
        : [];
      return dropdownValues;
    }

    field.config.payload.isLoading = true;

    const eventPairId = genTinyGUID(24); // TODO: Replace this with cypto.randomUUID() when TS is updated
    const logSrc = 'workflow';
    this.logEvent('ecp.ui.picklist', {
      eventState: 'start',
      correlationId: eventPairId,
      source: logSrc,
      keys: 'BusinessType'
    });

    const picklistTypes = this.l360ApiService.getPickListTypes('BusinessType');
    if (picklistTypes?.length > 0) {
      const dropdownValues = picklistTypes[0].pickListItems;
      if (!dropdownValues || dropdownValues.length <= 0) {
        return;
      }
      const list = Array.from(new Set(dropdownValues)).map((item: any) => buildEnumItem(item.id, item.value));
      field.config.payload['dropdownLists'] = JSON.stringify(list);
      field.config.payload.isLoading = false;

      this.logEvent('ecp.ui.picklist', {
        eventState: 'end',
        correlationId: eventPairId,
        source: logSrc,
        keys: 'BusinessType'
      });

      return list;
    }
    return [];
  };

  public loadSpecificBusinessClassification = (
    context: LogicFnContext,
    id: number,
    targetFieldId: string,
    dependentFieldId: string
  ): void => {
    const targetField = this.fieldService.createField(targetFieldId, context.field.flowId);
    const dependentField = this.fieldService.createField(dependentFieldId, context.field.flowId);
    const sourceField = this.fieldService.createField(context.field.id, context.field.flowId);

    id = sourceField && (!id || id == 0) ? sourceField.data.valueNumber : id;

    if (targetField && (!id || id == 0)) {
      targetField.enum.length = 0;
    }

    // Only call the API when the enum is not loaded. Once enum loaded here, then it will not make api call
    if (targetField && id > 0) {
      const selectedValue = targetField.data.value;
      targetField.data.value = null;

      this.l360ApiService.getSpecificBusinessClassification(id).subscribe(
        (response) => {
          if (response?.data?.length > 0) {
            let enumvalue;
            targetField.enum.length = 0;
            response.data.forEach((element) => {
              enumvalue = {
                enumId: element.id,
                label: element.value,
                value: element.id,
                virtual: false
              };
              targetField.enum.push(enumvalue);
            });

            if (context?.field?.dirty) {
              setTimeout(() => {
                if (!targetField.enum.some((enumItem) => enumItem.value === selectedValue || selectedValue === 0)) {
                  targetField.data.value = null;
                  dependentField.enum.length = 0;
                  dependentField.data.value = null;
                }
              }, 300);
            }
            if (context?.field?.dirty) {
              targetField.dirty = false;
              dependentField.dirty = false;
              dependentField.enum.length = 0;
              targetField.data.value = null;
              dependentField.data.value = null;
            }
            // TODO: Evaluate the ms here, and need for setTimeout in general
            setTimeout(() => {
              targetField.data.value = selectedValue === 0 ? null : selectedValue;
            }, 300);
          }
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (err) => {}
      );
    }
  };

  public loadSpecificIndustryClassification = (context: LogicFnContext, id: number, targetFieldId: string): void => {
    const targetField = this.fieldService.createField(targetFieldId, context.field.flowId);

    if (targetField && (!id || id == 0)) {
      targetField.enum.length = 0;
    }
    // Only call the API when the enum is not loaded. Once enum loaded here, then it will not make api call
    if (targetField && id > 0) {
      const selectedValue = targetField.data.value;
      targetField.data.value = null;

      this.l360ApiService.getSpecificIndustryClassification(id).subscribe(
        (response) => {
          if (response?.data?.length > 0) {
            let enumvalue;
            targetField.enum.length = 0;
            response.data.forEach((element) => {
              enumvalue = {
                enumId: element.id,
                label: element.value,
                value: element.id,
                virtual: true
              };
              targetField.enum.push(enumvalue);
            });

            if (context?.field && !context.field.dirty) {
              setTimeout(() => {
                targetField.data.value = selectedValue;
                if (!targetField.enum.some((enumItem) => enumItem.value === selectedValue) || selectedValue === 0) {
                  targetField.data.value = null;
                  targetField.enum.length = 0;
                }
              }, 300);
            }

            if (context?.field?.dirty) {
              targetField.data.value = null;
              targetField.dirty = false;
            }
            // TODO: Evaluate the ms here, and need for setTimeout in general
            setTimeout(() => {
              targetField.data.value = selectedValue === 0 ? null : selectedValue;
            }, 300);
          }
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (err) => {}
      );
    }
  };

  public onChangeDependentAge = (context: LogicFnContext): void => {
    if (context.field?.data.value) {
      context.field.data.value = context.field.data.value.toString().replace(REMOVE_MULTIPLE_COMMAS_RX, ', ').trim();
    }
  };

  public removeCommaDependentAge = (context: LogicFnContext): void => {
    if (context.field?.data.value) {
      let tempDependent = context.field.data.value.toString().split(',');
      tempDependent = tempDependent.filter((t) => t !== '');
      context.field.data.value = tempDependent.join(', ').toString();
    }
  };

  /**
   * Add/Remove 1 item on specific option selected
   * @param context field context
   * @param path storage path
   * @param shouldAddToArray the reference option value to true/false for Add/Remove.
   */
  public addorRemoveFromArray = (context: LogicFnContext, path: string, shouldAddToArray = true, maxAllowedLength: number = null): void => {
    if (!context.field.config.payload) {
      context.field.config.payload = {};
    }

    if (!context.field.config.payload.isLoading) {
      context.field.config.payload.isLoading = true;
      const pathPageId = path.indexOf('#') > -1 ? getPageIterationId(context) : -1;
      if (pathPageId >= 0) {
        const pageIterationId = getPageIterationId(context);
        const arrayRoot = path.split('/$')[0].split('$')[0];
        const pageArrayRoot = processPath(arrayRoot, pageIterationId);
        this.checkAndAddorRemove(context, pageArrayRoot, shouldAddToArray, maxAllowedLength);
      } else {
        this.checkAndAddorRemove(context, path, shouldAddToArray, maxAllowedLength);
      }
    }
    return;
  };

  /**
   * Add or Remove item into Array based on Max Allowed Length.
   * @param path
   * @param shouldAddToArray
   * @param maxAllowedLength
   */
  private checkAndAddorRemove(context: LogicFnContext, path: string, shouldAddToArray: boolean, maxAllowedLength: number) {
    if (shouldAddToArray) {
      if (maxAllowedLength) {
        const currentSize = this.statefulService.arraySize(path);
        if (maxAllowedLength > currentSize) {
          this.statefulService.arrayAdd(path, () => {
            context.field.config.payload.isLoading = false;
          });
        } else {
          context.field.config.payload.isLoading = false;
        }
      } else {
        this.statefulService.arrayAdd(path, () => {
          context.field.config.payload.isLoading = false;
        });
      }
    } else {
      this.statefulService.arrayRemove(path);
      context.field.config.payload.isLoading = false;
    }
  }

  private parseStringToarray(value: string): string[] {
    try {
      return JSON.parse(value);
    } catch (error) {
      return [];
    }
  }
  private addFieldtoRequestList(fieldID: string) {
    const requestList = this.parseStringToarray(this.statefulService.wrap('mem:requestList').valueStringOnly);
    if (requestList.indexOf(fieldID) === -1) {
      requestList.push(fieldID);
    }
    this.statefulService.wrap('mem:requestList').value = JSON.stringify(requestList);
  }

  public setValueIfGreaterThanZero = (context: LogicFnContext, storageId: string, falseValue: PrimitiveType): void => {
    const iterationId = 0;
    if (context.field.data.value && context.field.data.valueNumber > 0 && context.field.data.isChanged) {
      this.statefulService.wrap(context.field.config.storageId, iterationId).value = context.field.data.value;
    } else {
      this.statefulService.wrap(storageId, iterationId).value = falseValue;
    }
  };

  public setValueBySelection = (context: LogicFnContext, storageId: string, value: PrimitiveType, falseValue: PrimitiveType): void => {
    if (context.field.data.value) {
      this.statefulService.wrap(storageId).value = value;
    } else {
      this.statefulService.wrap(storageId).value = falseValue;
    }
  };

  /**
   * Load OAO identification type
   * @param targetFieldId - ID of Enum
   */

  public oaoIdentificationTypesEnumBuilder = (context: LogicFnContext): ValueLabelItem[] => {
    const field = context.field;
    let membershipId = this.getMembershipId();

    if (!field.config.payload) {
      field.config.payload = {};
    }

    if (field.config.payload.membershipId != membershipId) {
      field.config.payload = {};
      field.config.payload.membershipId = membershipId;
    }

    if (
      field.config.payload.isLoading ||
      (field.config.payload['dropdownLists'] && (field.config.payload['dropdownLists'] as any).length > 0)
    ) {
      const dropdownValues = field.config.payload['dropdownLists']
        ? (JSON.parse(field.config.payload['dropdownLists'] as string) as ValueLabelItem[])
        : [];
      this.onChangeIdentificationTypes(context);
      return dropdownValues;
    }
    if (!membershipId || membershipId === 'null') {
      membershipId = this.getMembershipId();
      if (!membershipId || membershipId === 'null') {
        // retry will occur but we are lacking product info on cold load
        return [];
      }
    }
    field.config.payload.isLoading = true;
    this.l360ApiService.getIdentificationTypes(membershipId.toString()).subscribe((response: any) => {
      if (response?.data) {
        const dropdownValues = response.data;
        if (!dropdownValues) {
          return;
        }

        const fieldsTypeConfig = response.data;
        const list = Array.from(new Set(dropdownValues)).map((item: any) => buildEnumItem(item.id, item.name));
        const lstFieldsTypeConfig = Array.from(new Set(fieldsTypeConfig)).map((item: any) => buildEnumItem(item.id, item.fieldsTypeConfig));

        field.config.payload['dropdownLists'] = JSON.stringify(list);
        field.config.payload['fieldsTypeConfig'] = JSON.stringify(lstFieldsTypeConfig);
        field.config.payload.isLoading = false;
        this.onChangeIdentificationTypes(context);
        return list;
      }
    });

    return [];
  };

  public onChangeIdentificationTypes = (context: LogicFnContext): void => {
    try {
      const membershipTypeName = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipTypeName').valueString;
      let idType;
      if (membershipTypeName?.toLowerCase() === 'business') {
        idType = this.statefulService.wrap(context.field.config.storageId, null, context.field.pageIterationId).value;
      } else {
        idType = this.statefulService.wrap(context.field.config.storageId).value;
      }

      const objIdentificationChildFields: PersonalDynamic = JSON.parse(JSON.stringify(UIFieldMapping)) as PersonalDynamic;

      if (context.field.config.payload.fieldsTypeConfig && (context.field.config.payload.fieldsTypeConfig as any).length > 0) {
        const lstFieldsTypeConfig = context.field.config.payload['fieldsTypeConfig']
          ? (JSON.parse(context.field.config.payload['fieldsTypeConfig'] as string) as ValueLabelItem[])
          : [];

        this.setIdentificationTypes(context, lstFieldsTypeConfig, idType, objIdentificationChildFields);
      }
    } catch (e) {}
  };

  /**
   * Set IdentificationTypes
   * @param context page and iteration info
   * @param lstFieldsTypeConfig value holds the FieldsTypeConfig
   * @param idType value holds type of ID type
   * @param objIdentChildFields value holds Identification Child Fields
   */
  private readonly setIdentificationTypes = (
    context: LogicFnContext,
    lstFieldsTypeConfig: any,
    idType: any,
    objIdentChildFields: any
  ): void => {
    if (lstFieldsTypeConfig?.filter((t) => t.value === idType).length > 0) {
      const objSelectedTypeFields = lstFieldsTypeConfig.filter((t) => t.value === idType)[0].label as string;

      const fieldArrays = objSelectedTypeFields.split('|') as any[];
      fieldArrays.shift();

      if (!fieldArrays || fieldArrays.length === 0) {
        return;
      }

      fieldArrays.forEach((element) => {
        const uiFields = element.split(':') as any[];
        if (uiFields[0] !== 'IssuedByType') {
          if (objIdentChildFields[uiFields[0]]) {
            objIdentChildFields[uiFields[0]].isRequired = /true/i.test((uiFields[1] as string).toLowerCase());
          }
        } else if (uiFields[0] === 'IssuedByType' && objIdentChildFields.IssuedBy.isRequired) {
          switch (uiFields[1]) {
            case 'FreeText':
              objIdentChildFields.IssuingInstitution.isRequired = true;
              break;
            case 'Country':
              objIdentChildFields.IssuingCountry.isRequired = true;
              break;
            case 'State':
              objIdentChildFields.IssuingState.isRequired = true;
          }
        }
      });
      const identificationFieldsTypeConfigStorageId = context.field.config.storageId.replace('/idType', '/identificationFieldsTypeConfig');

      const membershipTypeName = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipTypeName').valueString;
      if (membershipTypeName?.toLowerCase() === 'business') {
        this.statefulService.wrap(identificationFieldsTypeConfigStorageId, null, context.field.pageIterationId).value =
          JSON.stringify(objIdentChildFields);
      } else {
        this.statefulService.wrap(identificationFieldsTypeConfigStorageId).value = JSON.stringify(objIdentChildFields);
      }
    } else {
      this.statefulService.wrap(context.field.config.storageId).value = null;
    }
  };

  /**
   *  Triggering  Validation on Loaad
   *    * @param context - context of the field
   */

  public onReValidateField = (context: LogicFnContext): void => {
    if (context.field.data.value) {
      context.field.dirty = true;
    }
  };

  /**
   *  Set Youth Membership age validation on load
   *    * @param context - context of the field
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onReValidateAgeField = (context: LogicFnContext, defaultMinAge: number, defaultMaxAge: number): void => {
    const isYouth = this.statefulService.wrap(OAO_MEMBERSHIP_IS_YOUTH_STORAGE_ID).value;

    /** If youth membership & Is Admin Tool flag is enabled then fecth Min & Max age from Admin Portal Db by calling API */
    if (isYouth) {
      const membershipId = this.getMembershipId();
      this.l360ApiService.getMemberships().subscribe((response: any) => {
        if (response?.data?.memberships) {
          const memberships = response.data.memberships.filter(
            (membership) => membership.membershipID.toString() === membershipId.toString()
          );
          memberships.forEach((element) => {
            this.statefulService.wrap(OAO_MEMBERSHIP_MIN_AGE_STORAGE_ID).value = element.minAge;
            this.statefulService.wrap(OAO_MEMBERSHIP_MAX_AGE_STORAGE_ID).value = element.maxAge;
          });
        }
      });
    }

    if (context.field.data.value) {
      context.field.dirty = true;
    }
  };

  /**
   * Load OAO Employment Status
   * @param targetFieldId - ID of Enum
   */
  public oaoEmploymentStatusEnumBuilder = (context: LogicFnContext): ValueLabelItem[] => {
    const field = context.field;
    const membershipId = this.getMembershipId();
    if (!field.config.payload) field.config.payload = {};

    if (field.config.payload.membershipId != membershipId) field.config.payload = { membershipId };

    if (
      field.config.payload.isLoading ||
      (field.config.payload['dropdownLists'] && (field.config.payload['dropdownLists'] as any).length > 0)
    ) {
      const dropdownValues = field.config.payload['dropdownLists']
        ? (JSON.parse(field.config.payload['dropdownLists'] as string) as ValueLabelItem[])
        : [];
      return dropdownValues;
    }
    field.config.payload.isLoading = true;
    this.l360ApiService.getEmploymentStatus(membershipId.toString()).subscribe((response: any) => {
      if (response?.data) {
        const dropdownValues = response.data;
        if (!dropdownValues) {
          return;
        }
        const list = Array.from(new Set(dropdownValues)).map((item: any) => buildEnumItem(item.name, item.name));
        const empStatusList = this.sortEnumList(list);
        field.config.payload = { ...field.config.payload, dropdownLists: JSON.stringify(empStatusList), isLoading: false };
        // setting value to html element after enum loaded from API
        this.setValueToHTMLElement(field, empStatusList);
        return empStatusList;
      }
    });

    return [];
  };

  /**
   * Load OAO Disclosure Content
   * @param pageId
   */
  public loadOAODisclosure = (_context: LogicFnContext): Promise<any> => {
    let disclosure: Disclosure[] = [];

    return new Promise<boolean>((resolve) => {
      if (_context.field.id === 'oao-application-checkpoint-disclosure') {
        disclosure = this.setCheckPointPageDisclosure(_context);
        _context.field.config.content = JSON.stringify(disclosure);
        resolve(true);
      } else if (_context.field.id === 'oao-application-review-disclosure') {
        this.l360ApiService.disclosureSub.subscribe((response) => {
          if (response?.length > 0) {
            this.handleResponseFromOAODisclosure(response, _context, resolve);
          }
        });
        this.l360ApiService.getDisclsoures();
      }
    });
  };

  private handleResponseFromOAODisclosure(response, _context, resolve) {
    let disclosure: Disclosure[] = [];
    let applicants: DisclosureApplicant[] = [];
    this.bundleHelperService.refreshBundle(() => {
      // Old data may not have category property. Filtering only disclosure category may endup in some old get filtered out
      // So returning all disclosures except crossSell and SmartSign
      disclosure = response.filter(
        (t) =>
          t.category?.toLowerCase() !== DisclosureCategory.CorssSell.toLowerCase() &&
          t.category?.toLowerCase() !== DisclosureCategory.SmartSign.toLowerCase()
      );
      // On race condition, get bundle or put bundle overrides the disclosure object from bundle so below code will
      // repopulate the data if it is overriden
      // Remove beloe temp code once long term fix available
      // Temp code start
      let tryCount = 0;
      const bundleSize = this.statefulService.arraySize('api:oaoMemberInformation/oaoDisclosure');
      const poll = () => {
        const size = this.statefulService.arraySize('api:oaoMemberInformation/oaoDisclosure');
        if (size < 1 && tryCount < 3) {
          tryCount++;
          this.l360ApiService.getFinalReviewDisclsoure().subscribe(() => {
            this.bundleHelperService.refreshBundle(() => {
              poll();
            });
          });
        }
      };
      if (this.l360ApiService.getIsDisclosureLoaded && bundleSize < 1 && disclosure.length > 1) {
        poll();
      }
      // Temp code End

      const lenderName = this.lenderService.lenderDataInfo?.lenderName;
      disclosure.forEach((item, i) => {
        applicants = [];
        item.content = item.content.replace(/{lenderName}/gi, lenderName);
        item.storageId = `api:oaoMemberInformation/oaoDisclosure/${i}/accepted`;
        item.agreedDateStorageId = `api:oaoMemberInformation/oaoDisclosure/${i}/disclosureAgreeDate`;
        this.setApplicants(item, item.isPDFFile || item.isLinkType, applicants, i);
      });
      this.statefulService.wrap('mem:hasDisclosure').value = !disclosure.length;
      _context.field.config.content = disclosure.length ? JSON.stringify(disclosure) : '';
      resolve(true);
    });
  }

  private setValueToHTMLElement(field: FieldInstance, enumList: ValueLabelItem[]) {
    const value = field.data.valueString;
    const dropDownList = document.getElementById(field.id) as HTMLSelectElement;
    if (dropDownList) {
      const selectedValue = enumList.filter((f) => f.value.toString() === value);
      if (selectedValue?.length > 0) {
        dropDownList.value = value;
      }
    }
  }

  private sortEnumList(list: ValueLabelItem[]): ValueLabelItem[] {
    return list.sort((n1, n2) => {
      if (n1.value > n2.value) {
        return 1;
      }

      if (n1.value < n2.value) {
        return -1;
      }

      return 0;
    });
  }

  /**
   * Set Application Check Point Page Disclosures
   * @param _context Logic Function Context
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private setCheckPointPageDisclosure(_context: LogicFnContext): Disclosure[] {
    const applicants: DisclosureApplicant[] = [];
    const lenderName = this.lenderService.lenderDataInfo?.lenderName;
    const inQuirydisclosure = this.adminPortalFeaturesService.config.disclosure || {};
    const disclosureTextLabel: string = this.dictionaryService.read('Review/label');
    if (!inQuirydisclosure.title) {
      inQuirydisclosure.title = 'Inquiry Disclosure';
    }
    if (!inQuirydisclosure.content) {
      inQuirydisclosure.content = this.dictionaryService.read('Review/InquiryDisclosure');
    }
    if (!inQuirydisclosure.acceptanceText) {
      inQuirydisclosure.acceptanceText = disclosureTextLabel;
    }
    inQuirydisclosure.content = inQuirydisclosure.content.replace(/{lenderName}/gi, lenderName).replace(/\$lenderName\$/gi, lenderName);
    // Add Disclosure Label text to dictionary for overridability

    const storagePath = 'api:oaoMemberInformation/oaoCheckPointDisclosure';
    const applicantList = this.getOAOApplicants();
    const i = 0;
    for (let j = 0; j < applicantList.length; j++) {
      applicants.push({
        accepted: this.statefulService.wrap(storagePath + `/${i}/applicants/${j}/isAccept`).value as boolean,
        storageId: storagePath + `/${i}/applicants/${j}/isAccept`,
        agreedDateStorageId: storagePath + `/${i}/applicants/${j}/acceptDateTime`,
        label: `${applicantList[j].firstName} ${applicantList[j].lastName}: ${inQuirydisclosure.acceptanceText}`,
        applicant: `${applicantList[j].firstName} ${applicantList[j].lastName}`
      });
    }

    const disclosure = [
      {
        accepted: false,
        content: inQuirydisclosure.content,
        allowToAccept: true,
        id: 'savings',
        isPDFFile: false,
        pdfFileName: '',
        title: inQuirydisclosure.title,
        applicants,
        isOpen: false
      }
    ];
    return disclosure;
  }

  /**
   * Set Applicants for Disclosures
   * @param item
   * @param checkAllowToAccept
   * @param applicants
   * @param i
   */
  private setApplicants(item: Disclosure, checkAllowToAccept: boolean, applicants: DisclosureApplicant[], i: number): void {
    let allowToAccept = false;
    const protocol = 'api:';
    const storagePath = 'oaoMemberInformation/oaoDisclosure';
    item.applicants.forEach((value, index) => {
      if (value.applicant) {
        const currentRequestBodyInSS = this.statefulService.wrap('ss:current-patch-request-body').valueString;
        const isAcceptBundleValue = this.statefulService.wrap(protocol + storagePath + `/${i}/applicants/${index}/isAccept`).value;
        const isFinalReviewDisclosureAgreed = this.statefulService.wrap(
          protocol + 'oaoMemberInformation/isFinalReviewDisclosureAgreed'
        ).value;
        const isAccept = this.customFunctionsService.determineIsAcceptValue(
          storagePath + `/${i}/applicants/${index}/isAccept`,
          currentRequestBodyInSS,
          isAcceptBundleValue,
          isFinalReviewDisclosureAgreed
        );
        if (isAccept && checkAllowToAccept) {
          allowToAccept = true;
        }
        applicants.push({
          accepted: isAccept,
          storageId: protocol + storagePath + `/${i}/applicants/${index}/isAccept`,
          agreedDateStorageId: protocol + storagePath + `/${i}/applicants/${index}/acceptDateTime`,
          label: `${
            item.placeHolderAcceptText
              ? item.placeHolderAcceptText.replace('$Applicant Name$', value.applicant)
              : `I, ${value.applicant}, authorize this credit check.`
          }`,
          applicant: `${value.applicant}`
        });
      }
    });
    item.applicants = applicants;
    item.allowToAccept = checkAllowToAccept ? allowToAccept : true;
  }

  /**
   *     Disable the filed
   *    * @param context - context of the field
   */

  public disableBusinessResOneEmailField = (context: LogicFnContext): boolean => {
    const hasRegisteredWithSSO = this.statefulService.wrap('api:registeredWithSSO').value as boolean;
    return context?.field?.pageIterationId !== 0 || hasRegisteredWithSSO;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public loadAuthorization = (context: LogicFnContext, mainFlag: string, primary: string, coboArray: string): void => {
    if (this.statefulService.wrap(mainFlag).value as boolean) {
      context.field.data.value = true;
      this.statefulService.wrap(mainFlag).value = this.statefulService.wrap(primary).valueString === 'true';
      return;
    }

    if (!this.statefulService.wrap(mainFlag).value) {
      context.field.data.value = false;
    }
  };

  /** Update bunlde for final review page authorization checkbox */
  public updateAuthorization = (context: LogicFnContext, mainFlag: string, primary: string, coboArray: string): void => {
    // disable checkbox untill the bundle update to avoid double click event by update the content. After bundle update clear the content.
    if (context?.field?.config) {
      context.field.config.content = 'disable';

      if (context.field.readableValue !== 'true') {
        setTimeout(() => {
          this.statefulService.wrap(mainFlag).value = false;
          context.field.config.content = '';
        }, 50);
        return;
      }

      if (this.statefulService.wrap(primary).valueString !== 'true') {
        setTimeout(() => {
          this.statefulService.wrap(mainFlag).value = false;
          context.field.config.content = '';
        }, 50);
        return;
      }

      const size = this.statefulService.arraySize('api:coBorrowers');
      for (let i = 0; i < size; i++) {
        if (this.statefulService.wrap(coboArray, null, i).valueString !== 'true') {
          setTimeout(() => {
            this.statefulService.wrap(mainFlag).value = false;
            context.field.config.content = '';
          }, 50);
          return;
        }
      }

      setTimeout(() => {
        this.statefulService.wrap(mainFlag).value = this.statefulService.wrap(primary).valueString === 'true';
        context.field.config.content = '';
      }, 50);
    }
  };

  /** Enable Authorize Checkbox on Mortgage final review page */
  public enableAuthorizeCheckbox = (_context: LogicFnContext): boolean => {
    return !_context?.field?.content;
  };

  /** On Branches Changes */
  public onChangeBranch = (context: LogicFnContext, targetFieldId: string): void => {
    const targetField = this.fieldService.createField(targetFieldId, context.field.flowId, null, context.field.pageIterationId);
    if (targetField) {
      this.statefulService.wrap(targetField.config.storageId).value = null;
      targetField.dirty = false;
    }
    const branchId = context.field.data.value && context.field.data.valueNumber > 0 ? context.field.data.value.toString() : '';
    this.loadBranchUsers(null, branchId);
  };

  // Get Applicant Name
  public getApplicant = (apiPrimaryRoot: string): Name => {
    const applicantFullName: Name = {
      firstName: this.statefulService.wrap(`${apiPrimaryRoot}/firstName`).valueString,
      lastName: this.statefulService.wrap(`${apiPrimaryRoot}/lastName`).valueString
    };
    return applicantFullName;
  };

  // Get Applicant List
  public getOAOApplicants = (): Name[] => {
    const applicantList: Name[] = [];

    // 1. identify Membership Type 1. Personal = 1, 2. Youth = 2, 3. Business = 3,
    const membershipTypeName = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipTypeName').valueString;

    switch (membershipTypeName?.toLowerCase()) {
      case 'personal': {
        const objApplicant = this.getApplicant('api:oaoMemberInformation/primaryApplicant');
        applicantList.push(objApplicant);
        const hasCoApplicant = this.statefulService.wrap('api:oaoMemberInformation/hasCoApplicant').value as boolean;
        if (hasCoApplicant) {
          // eslint-disable-next-line @typescript-eslint/no-shadow
          const objApplicant = this.getApplicant('api:oaoMemberInformation/coApplicant');
          applicantList.push(objApplicant);
        }
        const additionalCoApplicantOption = this.statefulService.wrap('api:oaoMemberInformation/hasAdditionalCoApplicant').value as boolean;
        if (additionalCoApplicantOption) {
          // eslint-disable-next-line @typescript-eslint/no-shadow
          const objApplicant = this.getApplicant('api:oaoMemberInformation/additionalCoApplicant');
          applicantList.push(objApplicant);
        }
        break;
      }
      case 'business': {
        const responsiblePartyCount = this.statefulService.wrap(
          'api:oaoMemberInformation/businessInformation/responsiblePartyCount'
        ).valueStringOnly;
        if (Number.parseInt(responsiblePartyCount) > 0) {
          const responsibleParties = this.statefulService.arraySize('api:oaoMemberInformation/businessInformation/responsibleParties');
          for (let i = 0; i < responsibleParties; i++) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const objApplicant = this.getApplicant(`api:oaoMemberInformation/businessInformation/responsibleParties/${i}`);
            applicantList.push(objApplicant);
          }
        }
        break;
      }
      default:
        break;
    }

    return applicantList;
  };

  public setCoborrowerAsJointApplicant = (): void => {
    const firstCoBorrowerIndex = 0;
    const IsJoinCredit = this.statefulService.wrap('api:borrowerInfo/questionIsThereAJointApplication').value;
    const coBorrowers = this.statefulService.arraySize(coBorrowersPath(PROTOCOL_MORTGAGE));
    if (IsJoinCredit == true && coBorrowers && coBorrowers == 1) {
      const primaryEntityId = this.statefulService.wrap('api:entityId').value;
      this.statefulService.wrap(`api:coBorrowers/${firstCoBorrowerIndex}/parentId`).value = primaryEntityId;
      this.statefulService.wrap(`api:coBorrowers/${firstCoBorrowerIndex}/borrowerInfo/isCoBorrowerAJointApplication`).value = true;
    }
  };

  public showJointCredit = (): boolean => {
    const joinCredit = this.statefulService.wrap('api:borrowerInfo/questionIsThereAJointApplication').value;
    if (!joinCredit) {
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    const coBorrowerCount = 1 as number;
    const coBorrowers = this.statefulService.arraySize(coBorrowersPath(PROTOCOL_MORTGAGE));
    return coBorrowers !== coBorrowerCount;
  };

  /* Mortgage Employment Alert Section*/
  public alertMortgageEmployment = (
    context: LogicFnContext,
    endDateStorageId: string,
    startDatestorageId: any,
    useLastCard?: boolean
  ): void => {
    const pageiterationId = getPageIterationId(context);
    const arrayRoot = startDatestorageId.split('/$')[0].split('$')[0];
    const pageArrayRoot = processPath(arrayRoot, pageiterationId);
    const currentSize = this.statefulService.arraySize(arrayRoot, pageiterationId);
    const _context = context.field || context.card;
    const iterationId = useLastCard ? currentSize - 1 : _context.iterationId;

    let isCobrrower = false;
    if (pageArrayRoot.includes('api:coBorrowers')) {
      isCobrrower = true;
    }

    const monthAlertStorageId = isCobrrower ? 'ss:alert-months-input-co-borrower-#-$' : 'ss:alert-months-input-$';
    const daysAlertStorageId = isCobrrower ? 'ss:alert-days-input-co-borrower-#-$' : 'ss:alert-days-input-$';
    const daysDiffStorageId = isCobrrower ? 'ss:alert-diff-days-input-co-borrower-#-$' : 'ss:alert-diff-days-input-$';
    const emplyStatusStorageId = isCobrrower ? 'api:coBorrowers/#/employments/$/employmentStatus' : 'api:employments/$/employmentStatus';
    const empstatus = this.statefulService.wrap(emplyStatusStorageId, iterationId, pageiterationId).value;

    if (
      (empstatus &&
        empstatus.toString().toLowerCase() != 'current' &&
        !this.statefulService.wrap(endDateStorageId, iterationId, pageiterationId).value) ||
      !this.statefulService.wrap(startDatestorageId, iterationId, pageiterationId).value
    ) {
      return;
    }

    this.updatePropertyInArray(context, arrayRoot, [monthAlertStorageId, daysAlertStorageId], false);

    if (currentSize > 0) {
      this.triggerMonthandDaysAlert({
        context,
        endDateStorageId,
        startDatestorageId,
        emplyStatusStorageId,
        daysDiffStorageId,
        daysAlertStorageId,
        monthAlertStorageId,
        iterationId,
        isCobrrower
      });
    }
  };

  private readonly showCurrentDateEmploymentGaps = (
    context: LogicFnContext,
    isCobrrower,
    pageIterationId,
    startDatestorageId,
    endDateStorageId,
    dateobj
  ) => {
    const arrayRoot = startDatestorageId.split('/$')[0].split('$')[0];
    const currentSize = this.statefulService.arraySize(arrayRoot, pageIterationId);
    const fieldIndex = context?.field?.iterationId ?? currentSize - 1;
    let currentDaysGaps = 0;
    const empCurrentStorageId = isCobrrower ? 'api:coBorrowers/#/employments/$/employmentStatus' : 'api:employments/$/employmentStatus';
    const currentDateAlertStorageId = isCobrrower ? 'ss:alert-current-date-input-co-borrower-#-$' : 'ss:alert-current-date-input-$';
    const currentDateDaysGapAlertStorageId = isCobrrower
      ? 'ss:alert-current-date-days-input-co-borrower-#-$'
      : 'ss:alert-current-date-days-input-$';

    if (!currentSize || currentSize <= 0) {
      this.statefulService.wrap(currentDateAlertStorageId, fieldIndex, pageIterationId).value = false;
      this.statefulService.wrap(currentDateDaysGapAlertStorageId, fieldIndex, pageIterationId).value = 0;
      return;
    }

    for (let i = 0; i < currentSize; i++) {
      const currentStatus = this.statefulService.wrap(empCurrentStorageId, i, pageIterationId).valueString;
      const isCurrentEmployment = currentStatus?.toLowerCase() === 'current';
      const endDateFromUI = this.statefulService.wrap(endDateStorageId, i, pageIterationId).valueString;
      currentDaysGaps = !isCurrentEmployment ? this.dayDiff(new Date(), endDateFromUI) : 0;
      if (isCurrentEmployment || currentDaysGaps <= 30) {
        this.statefulService.wrap(currentDateAlertStorageId, i, pageIterationId).value = false;
        return;
      }
    }

    const endDate = dateobj[0].end ? dateobj[0].end : new Date();
    currentDaysGaps = this.dayDiff(new Date(), endDate);
    this.statefulService.wrap(currentDateAlertStorageId, dateobj[0].iterationId, pageIterationId).value = true;
    this.statefulService.wrap(currentDateDaysGapAlertStorageId, dateobj[0].iterationId, pageIterationId).value = currentDaysGaps;
  };

  private readonly triggerMonthandDaysAlert = (data: {
    context: LogicFnContext;
    endDateStorageId: string;
    startDatestorageId: any;
    emplyStatusStorageId: string;
    daysDiffStorageId: string;
    daysAlertStorageId: string;
    monthAlertStorageId: string;
    iterationId: number;
    isCobrrower: boolean;
  }): void => {
    const {
      context,
      endDateStorageId,
      startDatestorageId,
      emplyStatusStorageId,
      daysDiffStorageId,
      daysAlertStorageId,
      monthAlertStorageId,
      iterationId,
      isCobrrower
    } = data;
    const pageIterationId = getPageIterationId(context);
    const arrayRoot = startDatestorageId.split('/$')[0].split('$')[0];
    const currentSize = this.statefulService.arraySize(arrayRoot, pageIterationId);
    if (!currentSize || currentSize == 0) {
      return;
    }

    let totalMonths = 0;
    const dates = [] as any;

    for (let i = 0; i < currentSize; i++) {
      const startDate = this.statefulService.wrap(startDatestorageId, i, pageIterationId).valueString;
      const currentStatus = this.statefulService.wrap(emplyStatusStorageId, i, pageIterationId).valueString;
      const isCurrentEmployment = currentStatus?.toLowerCase() === 'current';
      const endDateFromUI = this.statefulService.wrap(endDateStorageId, i, pageIterationId).valueString;
      const endDate = isCurrentEmployment ? new Date().toString() : endDateFromUI;
      if (startDate && endDate) {
        dates.push({ start: new Date(startDate), end: new Date(endDate), iterationId: i, pageIterationId });
      }
    }

    if (dates?.length == 0) return;

    const dateobj = this.getStartAndEndDates(dates);

    if (dateobj?.length == 0) return;

    /** Current employment date not covered scenario */
    setTimeout(() => {
      this.showCurrentDateEmploymentGaps(context, isCobrrower, pageIterationId, startDatestorageId, endDateStorageId, dateobj);
    }, 0);
    /** Current employment date not covered scenario */

    // Trigger Minumum Month alert
    for (const element of dateobj) {
      const start = element.start;
      const end = element.end;
      totalMonths += this.monthDifference(start, end);
    }
    setTimeout(() => {
      this.statefulService.wrap(monthAlertStorageId, iterationId, pageIterationId).value = totalMonths < 24;
    }, 0);

    // Trigger Day diffrence alert
    for (let i = dateobj.length - 1; i > 0; i--) {
      const start = dateobj[i].end; // prev card endate
      const end = dateobj[i - 1].start; // current card card start date
      const gapDays = this.dayDiff(start, end);
      const isGapCardExist = dates.filter((e) => e.start >= start && e.end <= end).length > 0;
      if (gapDays > 30 && isGapCardExist == false) {
        const currentIterationId =
          dateobj[i].iterationId > dateobj[i - 1].iterationId ? dateobj[i].iterationId : dateobj[i - 1].iterationId;
        setTimeout(() => {
          this.setStorageValues(daysDiffStorageId, daysAlertStorageId, gapDays, iterationId, pageIterationId, currentIterationId);
        }, 0);
      }
    }
  };

  // Moved logic from above method for SQ Cognitive Complexity.
  private setStorageValues(daysDiffStorageId, daysAlertStorageId, gapDays, iterationId, pageIterationId, currentIterationId) {
    if ((daysDiffStorageId.includes(PATH_ITERATION_SYMBOL) && currentIterationId) || !daysDiffStorageId.includes(PATH_ITERATION_SYMBOL)) {
      this.statefulService.wrap(daysDiffStorageId, iterationId, pageIterationId).value = gapDays;
    }
    if ((daysAlertStorageId.includes(PATH_ITERATION_SYMBOL) && currentIterationId) || !daysAlertStorageId.includes(PATH_ITERATION_SYMBOL)) {
      this.statefulService.wrap(daysAlertStorageId, iterationId, pageIterationId).value = true;
    }
  }

  private readonly getStartAndEndDates = (dates) => {
    dates = this.sortDates(dates, 'desc');
    const nonSingleEntryDates = dates.filter((t) => !t.isSingleEntry);
    let startDate = nonSingleEntryDates[0].start;
    let endDate = nonSingleEntryDates[0].end;
    const filteredDates = dates.filter(
      (t) => (t.start <= startDate && t.end >= endDate) || (t.start <= startDate && t.end <= endDate && t.end >= startDate)
    );

    if (filteredDates?.length > 1) {
      const startDates = filteredDates.map((t) => t.start).sort((n1, n2) => n1 - n2);
      const endDates = filteredDates.map((t) => t.end).sort((n1, n2) => n2 - n1);
      dates = this.notMatched(dates, filteredDates);
      startDate = startDates[0];
      endDate = endDates[0];
      // eslint-disable-next-line quote-props
      dates.push({ start: startDate, end: endDate, isProcessed: true });
    } else {
      nonSingleEntryDates[0].isSingleEntry = true;
      nonSingleEntryDates[0].isProcessed = true;
    }

    if (dates?.filter((t) => !t.isProcessed).length > 0) {
      dates = this.getStartAndEndDates(dates);
    }
    return dates;
  };

  private readonly notMatched = (arr1, arr2) => {
    const ret = [];
    for (const i in arr1) {
      if (arr2.indexOf(arr1[i]) == -1) {
        ret.push(arr1[i]);
      }
    }
    return ret;
  };

  private readonly sortDates = (dates, sortType = 'asc', sortBy = 'start') => {
    return dates.sort((a, b) => {
      if (sortType == 'asc') {
        return a[sortBy] - b[sortBy];
      }

      return b[sortBy] - a[sortBy];
    });
  };

  private readonly monthDifference = (startDate, endDate) => {
    let months;
    endDate = new Date(endDate);
    startDate = new Date(startDate);
    months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += endDate.getMonth();
    return months <= 0 ? 0 : months;
  };

  private readonly dayDiff = (preInputDate, startInputDate) => {
    const diff = Math.abs(new Date(preInputDate).getTime() - new Date(startInputDate).getTime());
    const differenceDays = Math.ceil(diff / (1000 * 3600 * 24));
    return differenceDays;
  };

  public updatePropertyInArray = (_context: LogicFnContext, apiRoot: string, storageIds: string[], value: PrimitiveType) => {
    const pageiterationId = getPageIterationId(_context);
    const length = this.statefulService.arraySize(apiRoot, pageiterationId);

    storageIds.forEach((storageId) => {
      for (let i = 0; i < length; i++) {
        this.statefulService.wrap(storageId, i, pageiterationId).value = value;
      }
    });
  };

  public updateProperty = (_context: LogicFnContext, apiRoot: string, storageId: string, value: PrimitiveType) => {
    setTimeout(() => {
      const cardSize = this.statefulService.arraySize(`${apiRoot}`, _context.field.pageIterationId);
      for (let i = cardSize; i > 0; i--) {
        this.statefulService.wrap(storageId, i - 1, _context.page.pageIterationId).value = value;
      }
    });
  };

  /**
   * Method set a property value to most recent record.
   * @param _context field context
   * @param apiRoot root object of the property
   * @param storageId storage id to setvalue
   * @param value value to update
   */
  public updateMostRecentProperty = (_context: LogicFnContext, apiRoot: string, storageId: string, value: PrimitiveType) => {
    const pageIterationId = getPageIterationId(_context);
    setTimeout(() => {
      const cardSize = this.statefulService.arraySize(`${apiRoot}`, pageIterationId);
      if (cardSize > 0) {
        this.statefulService.wrap(storageId, cardSize - 1, pageIterationId).value = value;
      }
    });
  };

  /**
   * Load OAO Income Frequency
   * @param targetFieldId - ID of Enum
   */
  public oaoIncomeFrequencyEnumBuilder = (context: LogicFnContext): ValueLabelItem[] => {
    const field = context.field;

    if (!field.config.payload) {
      field.config.payload = {};
    }

    if (
      field.config.payload.isLoading ||
      (field.config.payload['dropdownLists'] && (field.config.payload['dropdownLists'] as any).length > 0)
    ) {
      const dropdownValues = field.config.payload['dropdownLists']
        ? (JSON.parse(field.config.payload['dropdownLists'] as string) as ValueLabelItem[])
        : [];
      return dropdownValues;
    }
    field.config.payload.isLoading = true;
    this.l360ApiService.getIncomeFrequency().subscribe((response: any) => {
      if (response?.data) {
        const dropdownValues = response.data;
        if (!dropdownValues) {
          return;
        }
        const list = Array.from(new Set(dropdownValues)).map((item: any) => {
          const objFrequency = item.name.toLowerCase() == 'bi-weekly' ? 'Biweekly' : item.name;
          return buildEnumItem(objFrequency, item.name);
        });

        field.config.payload['dropdownLists'] = JSON.stringify(list);
        field.config.payload.isLoading = false;
        return list;
      }
    });

    return [];
  };

  /**
   * OAO ONLY
   * Remove additional co-applicant if co-app is empty
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onChangeAdditionalCoApp = (context: LogicFnContext): void => {
    if (!this.visibleFunctionsService.visibleIsOAOInstatouchEnabled()) {
      this.statefulService.wrap('api:oaoMemberInformation/coApplicant/autoFillOption').value = 'Manual';
      this.statefulService.wrap('mem:primary-application-status-co-applicant').value = true;
    } else {
      this.statefulService.wrap('api:oaoMemberInformation/coApplicant/autoFillOption').value = null;
      this.statefulService.wrap('mem:primary-application-status-co-applicant').value = null;
    }
    this.l360ApiService.clearDisclosure();
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onChangeAdditionalJointCoApp = (context: LogicFnContext): void => {
    if (!this.visibleFunctionsService.visibleIsOAOInstatouchEnabled()) {
      this.statefulService.wrap('api:oaoMemberInformation/additionalCoApplicant/autoFillOption').value = 'Manual';
      this.statefulService.wrap('mem:primary-application-status-additional-co-app').value = true;
    } else {
      this.statefulService.wrap('api:oaoMemberInformation/additionalCoApplicant/autoFillOption').value = null;
      this.statefulService.wrap('mem:primary-application-status-additional-co-app').value = null;
    }
    this.oaoPageHelper.deleteOaoApplicant('api:oaoMemberInformation/additionalCoApplicant');
    this.l360ApiService.clearDisclosure();
  };

  public resetAddress = (context: LogicFnContext, rootPath: string): void => {
    const pageiterationId = getPageIterationId(context);
    const iterationId = context.field.iterationId;
    const storageId = context.field.config.storageId;
    const arrayRoot = storageId.split('/$')[0].split('$')[0];
    const pageArrayRoot = processPath(arrayRoot, pageiterationId);
    const initStorage = pageArrayRoot.includes('api:coBorrowers') ? 'api:coBorrowers/#/' : 'api:';
    this.statefulService.wrap(`${initStorage}${rootPath}/address1`, iterationId, pageiterationId).value = null;
    this.statefulService.wrap(`${initStorage}${rootPath}/address2`, iterationId, pageiterationId).value = null;
    this.statefulService.wrap(`${initStorage}${rootPath}/city`, iterationId, pageiterationId).value = null;
    this.statefulService.wrap(`${initStorage}${rootPath}/state`, iterationId, pageiterationId).value = null;
    this.statefulService.wrap(`${initStorage}${rootPath}/zip`, iterationId, pageiterationId).value = null;
  };

  /**
   * Load OAO Membership Names
   * @param targetFieldId - ID of Enum
   */
  public setOAOMembershipCheckPointPage = (context: LogicFnContext, targetFieldId: string): void => {
    const targetField = this.fieldService.createField(targetFieldId, context.field.flowId);

    // Only call the API when the enum is not loaded. Once enum loaded here, then it will not make api call
    if (targetField?.enum?.length === 0) {
      this.l360ApiService.getMemberships().subscribe((response: any) => {
        if (response?.data?.memberships) {
          const memberships = response.data.memberships.filter(
            (membership) =>
              membership.membershipTypeName.toString().toLowerCase() === 'personal' ||
              membership.membershipTypeName.toString().toLowerCase() === 'business'
          );

          let enumvalue;
          memberships.forEach((element) => {
            enumvalue = {
              enumId: element.membershipTypeName,
              isYouth: element.isYouth,
              label: element.membershipName,
              maxAge: element.maxAge,
              description: element.description,
              redirectURL: element.redirectURL,
              membershipFee: element.membershipFee,
              minAge: element.minAge,
              value: element.membershipID?.toString(),
              virtual: false
            };
            targetField.enum.push(enumvalue);
          });
          // targetField.enum. = enumValue;
          memberships.sort((a, b) => a.membershipName.localeCompare(b.membershipName));
          targetField.enum.sort((a, b) => a.label.localeCompare(b.label));
        }
        targetField.data.value = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipID').value;
      });
    } else {
      targetField.data.value = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipID').value;
    }
  };

  /**
   * Load Responsible list for business
   *   * @param arrayPath - Path of respective business array
   */
  /** To load Responsible,Additional Reponsible and Authorized card List */
  public onChangeResponsiblePartiesDDL = (context: LogicFnContext, arrayPath: string): void => {
    const arrayCount = this.statefulService.arraySize(arrayPath);
    if (
      arrayCount > 0 &&
      (!this.statefulService.wrap(OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_FIRSTNAME).valueStringOnly ||
        !this.statefulService.wrap(OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_EMAIL).valueStringOnly)
    ) {
      this.statefulService.wrap(OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_FIRSTNAME).value =
        this.statefulService.wrap(OAO_PRIMARY_APPLICANT_FIRSTNAME).value;
      this.statefulService.wrap(OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_LASTNAME).value =
        this.statefulService.wrap(OAO_PRIMARY_APPLICANT_LASTNAME).value;
      this.statefulService.wrap(OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_MOBILENUMBER).value =
        this.statefulService.wrap(OAO_PRIMARY_APPLICANT_MOBILENUMBER).value;
      this.statefulService.wrap(OAO__BUSSINESS_APP_RESPONSIBE_PARTY_ONE_EMAIL).value =
        this.statefulService.wrap(OAO_PRIMARY_APPLICANT_EMAIL).value;
    }
  };

  /**
   * Load OAO Housing type
   * @param targetFieldId - ID of Enum
   */
  public oaoHousingTypeEnumBuilder = (context: LogicFnContext): ValueLabelItem[] => {
    const field = context.field;

    if (!field.config.payload) {
      field.config.payload = {};
    }

    if (
      field.config.payload.isLoading ||
      (field.config.payload['dropdownLists'] && (field.config.payload['dropdownLists'] as any).length > 0)
    ) {
      const dropdownValues = field.config.payload['dropdownLists']
        ? (JSON.parse(field.config.payload['dropdownLists'] as string) as ValueLabelItem[])
        : [];
      return dropdownValues;
    }

    field.config.payload.isLoading = true;

    const eventPairId = genTinyGUID(24); // TODO: Replace this with cypto.randomUUID() when TS is updated
    const logSrc = 'workflow';
    this.logEvent('ecp.ui.picklist', {
      eventState: 'start',
      correlationId: eventPairId,
      source: logSrc,
      keys: 'OwnershipCode'
    });

    const picklistTypes = this.l360ApiService.getPickListTypes('OwnershipCode');
    if (picklistTypes?.length > 0) {
      const dropdownValues = picklistTypes[0].pickListItems;
      if (!dropdownValues || dropdownValues.length <= 0) {
        return;
      }
      const list = Array.from(new Set(dropdownValues)).map((item: any) => buildEnumItem(item.id, item.value));
      field.config.payload['dropdownLists'] = JSON.stringify(list);
      field.config.payload.isLoading = false;

      this.logEvent('ecp.ui.picklist', {
        eventState: 'end',
        correlationId: eventPairId,
        source: logSrc,
        keys: 'OwnershipCode'
      });

      return list;
    }
    return [];
  };

  public loadSlideoutContent = (): Promise<SlideOutContent> => {
    return new Promise<SlideOutContent>((resolve) => {
      const content: SlideOutContent = {
        title: 'About Demographics',
        header: 'Why do we ask this?',
        description: `<b> The purpose of collecting this information </b> is to help ensure that all applicants are treated fairly and that
        the housing needs of communities and neighborhoods are being fulfilled. For residential mortgage lending, Federal law requires
        that we ask applicants for their demographic information (ethnicity, race, and sex) in order to monitor our compliance with
        equal credit opportunity, fair housing, and home mortgage disclosure laws. You are not required to provide this information,
        but are encouraged to do so. You may select one or more designations for "Ethnicity" and one or more designations for "Race".
        <b> The law provides that we may not discriminate </b> on the basis of this information, or on whether you choose to provide it.
        If you do not wish to provide some or all of this information, select “No, decline to provide.”`
      };
      resolve(content);
    });
  };

  public loadEconsentContent = (): Promise<SlideOutContent> => {
    const lenderName = this.lenderService?.lenderData?.lenderName;
    return new Promise<SlideOutContent>((resolve) => {
      this.l360ApiService.getLegalDocuments('econsent').subscribe(
        (blob) => {
          blob
            .text()
            .then((response) => {
              const content: SlideOutContent = {
                title: 'E-Consent Policy',
                header: `${lenderName ? `${lenderName} ` : ''}E-Consent Policy`,
                description: response
              };
              resolve(content);
            })
            .catch(() => resolve({} as SlideOutContent));
        },
        () => resolve({} as SlideOutContent)
      );
    });
  };

  /**
   * Load OAO memerships from enum builder
   * @param targetFieldId - ID of Enum
   */
  public oaoMembershipsEnumBuilder = (context: LogicFnContext): ValueLabelItem[] => {
    const field = context.field;
    if (!field.config.payload) {
      field.config.payload = {};
    }
    if (
      field.config.payload.isLoading ||
      (field.config.payload['dropdownLists'] && (field.config.payload['dropdownLists'] as any).length > 0)
    ) {
      const dropdownValues = field.config.payload['dropdownLists']
        ? (JSON.parse(field.config.payload['dropdownLists'] as string) as ValueLabelItem[])
        : [];
      return dropdownValues;
    }

    field.config.payload.isLoading = true;
    this.l360ApiService.getMemberships().subscribe((response: any) => {
      const memberships = response?.data;
      if (!memberships) {
        return;
      }

      const dropdownValues = response.data.memberships.filter((membership) =>
        ['personal', 'business'].includes(membership.membershipTypeName.toString().toLowerCase())
      );

      const organizationID = response.data.organizationID ? response.data.organizationID : 0;
      this.statefulService.wrap('api:oaoMemberInformation/membership/organizationID').value = Number(organizationID);

      const membershipsList: any[] = [];
      dropdownValues.forEach((element) => {
        const enumvalue = {
          enumId: element.membershipTypeName,
          icon: element.isYouth ? 'Youth' : element.membershipTypeName,
          isYouth: element.isYouth,
          label: element.membershipName,
          maxAge: element.maxAge,
          description: element.description,
          isEnabledChecklist: element.isEnabledChecklist,
          checklistDescription: element.checklistDescription,
          membershipFee: element.membershipFee,
          minAge: element.minAge,
          value: element.membershipID?.toString(),
          virtual: false,
          isPromoCode: element.maxPromoCodeDisplay > 0,
          organizationID,
          redirectURL: element.redirectURL,
          isHideMembershipSelection: element.isHideMembershipSelection
        };
        membershipsList.push(enumvalue);
      });

      membershipsList.sort((a, b) => a.label.localeCompare(b.label));

      field.config.payload['dropdownLists'] = JSON.stringify(membershipsList?.filter((mem) => mem.isHideMembershipSelection !== true));
      field.config.payload.isLoading = false;
      return membershipsList;
    });

    return [];
  };

  /** refreshBundle */
  public refreshBundle = (): void => {
    this.bundleHelperService.refreshBundle();
  };

  /* Get MembershipId */
  private getMembershipId(): string {
    const bundleMembershipId = this.statefulService.wrap(OAO_MEMBERSHIPID_STORAGE_ID).value;
    const dropdownMembershipId = this.statefulService.wrap(OAO_DROPDOWN_MEMBERSHIPID_STORAGE_ID).value;
    if (!bundleMembershipId && !dropdownMembershipId) {
      const memMembershipId = this.statefulService.wrap('mem:oaoMemberInformation/membership/membershipID').value;
      const memdropdownMembershipId = this.statefulService.wrap('ss:oaoMemberInformation/membership/dropdownMembershipID').value;
      const tempMembershipId = memMembershipId || memdropdownMembershipId;
      if (!tempMembershipId) {
        return 'null';
      }
      return tempMembershipId.toString();
    }
    const membershipId = bundleMembershipId ? bundleMembershipId.toString() : dropdownMembershipId.toString();
    return membershipId;
  }

  /**
   * Set Consent Acceptance date
   * @param context Field
   * @param fieldId FieldId for AcceptedDate
   */
  public setAcceptedDate = (context: LogicFnContext, fieldId: string): void => {
    try {
      const isAccepted = context.field.data.value;
      if (isAccepted) {
        this.statefulService.wrap(fieldId, context.field.iterationId, context.field.pageIterationId).value = new Date().toISOString();
      } else {
        this.statefulService.wrap(fieldId, context.field.iterationId, context.field.pageIterationId).value = null;
      }
    } catch (e) {}
  };
}
